/* eslint-disable */

/* THIS FILE IS AUTOGENERATED. */


export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CMS_SSR_Date: any;
  CMS_SSR_DateTime: any;
  CMS_SSR_Decimal: any;
  CMS_SSR_JSONString: any;
  CMS_SSR_PositiveInt: any;
  CMS_SSR_UUID: any;
  Date: string;
  JSON: Record<string, unknown>;
};

export type BooleanQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type CMS_SSR = {
  __typename: 'CMS_SSR';
  activeLicenceTypes: Array<CMS_SSR_LicenceTypeInterface>;
  awards: Array<CMS_SSR_AwardInterface>;
  bigSpecimenSet: Maybe<CMS_SSR_BigSpecimenSet>;
  blogCategories: Array<CMS_SSR_BlogTagInterface>;
  blogPost: Maybe<CMS_SSR_BlogPage>;
  blogPosts: Maybe<Array<CMS_SSR_BlogPage>>;
  collections: Array<Maybe<CMS_SSR_CollectionObjectType>>;
  config: CMS_SSR_ConfigInterface;
  customFont: Maybe<CMS_SSR_CustomFontInterface>;
  customFonts: Array<CMS_SSR_CustomFontInterface>;
  debug: Maybe<CMS_SSR_DjangoDebug>;
  document: Maybe<CMS_SSR_DocumentObjectType>;
  documentType: Scalars['String'];
  documents: Array<CMS_SSR_DocumentObjectType>;
  fontFamilies: Array<CMS_SSR_FontFamilyInterface>;
  fontFamily: Maybe<CMS_SSR_FontFamilyInterface>;
  fontFamilyGroup: Maybe<CMS_SSR_FontFamilyGroupInterface>;
  fontFamilyGroups: Array<CMS_SSR_FontFamilyGroupInterface>;
  homepage: CMS_SSR_HomePage;
  image: Maybe<CMS_SSR_CustomImage>;
  imageType: Scalars['String'];
  images: Array<CMS_SSR_CustomImage>;
  inUseCategories: Array<CMS_SSR_TagInterface>;
  inUsePost: Maybe<CMS_SSR_FontsInUseDetailPage>;
  inUsePosts: Maybe<Array<CMS_SSR_FontsInUseDetailPage>>;
  mediumSpecimenSet: Maybe<CMS_SSR_MediumSpecimenSet>;
  page: Maybe<CMS_SSR_PageInterface>;
  pages: Array<CMS_SSR_PageInterface>;
  previewSpecimenSet: Maybe<CMS_SSR_PreviewSpecimenSet>;
  redirects: Array<CMS_SSR_Redirect>;
  search: Array<CMS_SSR_Search>;
  site: Maybe<CMS_SSR_SiteObjectType>;
  sites: Array<CMS_SSR_SiteObjectType>;
  smallSpecimenSet: Maybe<CMS_SSR_SmallSpecimenSet>;
  tag: Maybe<CMS_SSR_TagObjectType>;
  tags: Array<CMS_SSR_TagObjectType>;
  testFonts: CMS_SSR_TestFontsInterface;
};


export type CMS_SSRbigSpecimenSetArgs = {
  contentAmount: Scalars['Int'];
  fontFamily: Scalars['ID'];
};


export type CMS_SSRblogPostArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRblogPostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRcollectionsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRcustomFontArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRdocumentArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type CMS_SSRdocumentsArgs = {
  collection?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRfontFamilyArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRfontFamilyGroupArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRhomepageArgs = {
  order?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRimageArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type CMS_SSRimagesArgs = {
  collection?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRinUsePostArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRinUsePostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRmediumSpecimenSetArgs = {
  contentAmount: Scalars['Int'];
  fontFamily: Scalars['ID'];
};


export type CMS_SSRpageArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inSite?: InputMaybe<Scalars['Boolean']>;
  site?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRpagesArgs = {
  ancestor?: InputMaybe<Scalars['ID']>;
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inSite?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRpreviewSpecimenSetArgs = {
  fontFamily: Scalars['ID'];
  specimenConfig: Scalars['ID'];
};


export type CMS_SSRsearchArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRsiteArgs = {
  hostname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type CMS_SSRsitesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRsmallSpecimenSetArgs = {
  contentAmount: Scalars['Int'];
  fontFamily: Scalars['ID'];
};


export type CMS_SSRtagArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type CMS_SSRtagsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_AccountInterface = {
  __typename: 'CMS_SSR_AccountInterface';
  id: Scalars['ID'];
  user: CMS_SSR_UserInterface;
};

export type CMS_SSR_AwardInterface = {
  __typename: 'CMS_SSR_AwardInterface';
  customFonts: Array<CMS_SSR_CustomFontInterface>;
  essentialContribution: Scalars['Boolean'];
  fontFamilies: Array<CMS_SSR_FontFamilyInterface>;
  fontFamilyGroups: Array<CMS_SSR_FontFamilyGroupInterface>;
  id: Scalars['ID'];
  name: Scalars['String'];
  receivedFor: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  year: Scalars['Int'];
};

export type CMS_SSR_BigSpecimenSet = {
  __typename: 'CMS_SSR_BigSpecimenSet';
  fontSize: Scalars['Float'];
  fontStyles: Array<CMS_SSR_FontStyleWithWords>;
  letterSpacing: Scalars['Float'];
  lineHeight: Scalars['Float'];
  referenceWordCalculatedWidth: Scalars['Int'];
  specimensPerFontStyle: Scalars['Int'];
};

export type CMS_SSR_BlockQuoteBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_BlockQuoteBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_BlogIndexPage = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_BlogIndexPage';
  aliasOf: Maybe<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_BlogIndexPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogIndexPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogIndexPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogIndexPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogIndexPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogIndexPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_BlogPage = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_BlogPage';
  aliasOf: Maybe<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  author: Maybe<Scalars['String']>;
  blurb: Maybe<Scalars['String']>;
  blurbImage: CMS_SSR_CustomImage;
  body: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  categories: Array<CMS_SSR_BlogTag>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  feedImage: Maybe<CMS_SSR_CustomImage>;
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  fontFamilyGroups: Maybe<Array<CMS_SSR_FontFamilyGroupInterface>>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  hero: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  id: Maybe<Scalars['ID']>;
  intro: Maybe<Scalars['String']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  noindex: Scalars['Boolean'];
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  postDate: Scalars['CMS_SSR_DateTime'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  relatedBlogPosts: Array<CMS_SSR_BlogPage>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_BlogPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagecategoriesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagerelatedBlogPostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_BlogPostFeaturedFont = {
  __typename: 'CMS_SSR_BlogPostFeaturedFont';
  id: Maybe<Scalars['ID']>;
};

export type CMS_SSR_BlogTag = {
  __typename: 'CMS_SSR_BlogTag';
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type CMS_SSR_BlogTagInterface = {
  __typename: 'CMS_SSR_BlogTagInterface';
  blogTaggedblogbaseItems: Array<CMS_SSR_TaggedBlogBase>;
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type CMS_SSR_BooleanBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_BooleanBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Boolean'];
};

export type CMS_SSR_CampaignImageInterface = {
  __typename: 'CMS_SSR_CampaignImageInterface';
  colorBackground: Maybe<Scalars['String']>;
  colorLoaderBackground: Maybe<Scalars['String']>;
  colorLoaderForeground: Maybe<Scalars['String']>;
  created: Scalars['CMS_SSR_DateTime'];
  id: Scalars['ID'];
  imageLandscape: Scalars['String'];
  imageLandscapeHeight: Scalars['Int'];
  imageLandscapeWidth: Scalars['Int'];
  imagePortrait: Maybe<Scalars['String']>;
  imagePortraitHeight: Maybe<Scalars['Int']>;
  imagePortraitWidth: Maybe<Scalars['Int']>;
  layoutModeLandscape: CMS_SSR_CampaignLayoutMode;
  layoutModePortrait: CMS_SSR_CampaignLayoutMode;
  marginOverlapLandscape: Scalars['Int'];
  marginOverlapPortrait: Scalars['Int'];
  modified: Scalars['CMS_SSR_DateTime'];
  sortOrder: Scalars['Int'];
};

export type CMS_SSR_CampaignInterface = {
  __typename: 'CMS_SSR_CampaignInterface';
  created: Scalars['CMS_SSR_DateTime'];
  displayMode: CMS_SSR_CampaignsCampaignDisplayModeChoices;
  fontfamilySet: Array<CMS_SSR_FontFamilyInterface>;
  id: Scalars['ID'];
  images: Array<CMS_SSR_CampaignImageInterface>;
  modified: Scalars['CMS_SSR_DateTime'];
  svgHeadingOverlay: Scalars['Boolean'];
  transitionDuration: Scalars['Int'];
  transitionInterval: Scalars['Int'];
  type: CMS_SSR_CampaignsCampaignTypeChoices;
  videos: Array<CMS_SSR_CampaignVideoInterface>;
};

export enum CMS_SSR_CampaignLayoutMode {
  FULL_WIDTH = 'FULL_WIDTH',
  WITHIN_GRID = 'WITHIN_GRID'
}

export type CMS_SSR_CampaignVideoInterface = {
  __typename: 'CMS_SSR_CampaignVideoInterface';
  colorLoaderBackground: Maybe<Scalars['String']>;
  colorLoaderForeground: Maybe<Scalars['String']>;
  created: Scalars['CMS_SSR_DateTime'];
  id: Scalars['ID'];
  layoutModeLandscape: CMS_SSR_CampaignLayoutMode;
  layoutModePortrait: CMS_SSR_CampaignLayoutMode;
  marginOverlapLandscape: Scalars['Int'];
  marginOverlapPortrait: Scalars['Int'];
  modified: Scalars['CMS_SSR_DateTime'];
  videoLandscape: CMS_SSR_VimeoVideoInterface;
  videoPortrait: Maybe<CMS_SSR_VimeoVideoInterface>;
};

export enum CMS_SSR_CampaignsCampaignDisplayModeChoices {
  CROSS_FADE = 'CROSS_FADE',
  CROSS_FADE_RANDOM = 'CROSS_FADE_RANDOM',
  RANDOM_SINGLE = 'RANDOM_SINGLE'
}

export enum CMS_SSR_CampaignsCampaignTypeChoices {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export type CMS_SSR_CartInterface = {
  __typename: 'CMS_SSR_CartInterface';
  amountSubtotal: Scalars['Float'];
  amountSubtotalConverted: Scalars['Float'];
  amountSubtotalForFontsWithLicenceMultiplier: Scalars['Float'];
  amountTax: Scalars['Float'];
  amountTaxUsd: Scalars['Float'];
  amountTotal: Scalars['Float'];
  amountTotalUsd: Scalars['Float'];
  billingAddress1: Maybe<Scalars['String']>;
  billingAddress2: Maybe<Scalars['String']>;
  billingCity: Maybe<Scalars['String']>;
  billingCompanyName: Maybe<Scalars['String']>;
  billingCountry: Maybe<CMS_SSR_CountryChoices>;
  billingName: Maybe<Scalars['String']>;
  billingPostcode: Maybe<Scalars['String']>;
  billingPurchaseOrder: Maybe<Scalars['String']>;
  billingState: Maybe<Scalars['String']>;
  billingVatNumber: Maybe<Scalars['String']>;
  currency: Maybe<CMS_SSR_CurrencyChoices>;
  discounts: Array<CMS_SSR_DiscountInterface>;
  emailOptIn: Scalars['Boolean'];
  exchangeRate: Scalars['Float'];
  hasDownloadables: Scalars['Boolean'];
  hasFontlessItems: Scalars['Boolean'];
  hasSimpleLicensing: Scalars['Boolean'];
  id: Scalars['ID'];
  invoiceExtraDescription: Maybe<Scalars['String']>;
  invoiceId: Maybe<Scalars['ID']>;
  invoiceNumber: Maybe<Scalars['String']>;
  isInvoice: Scalars['Boolean'];
  items: Array<CMS_SSR_LineItemInterface>;
  legacyBillingAddress: Maybe<Scalars['String']>;
  legacyLicensedTo: Maybe<Scalars['String']>;
  licenceTiers: Array<CMS_SSR_CartTierInterface>;
  licensedForSomeoneElse: Scalars['Boolean'];
  licensedToAddress1: Maybe<Scalars['String']>;
  licensedToAddress2: Maybe<Scalars['String']>;
  licensedToCity: Maybe<Scalars['String']>;
  licensedToCompanyName: Maybe<Scalars['String']>;
  licensedToCountry: Maybe<CMS_SSR_CountryChoices>;
  licensedToPostcode: Maybe<Scalars['String']>;
  licensedToState: Maybe<Scalars['String']>;
  licensedToVatNumber: Maybe<Scalars['String']>;
  nativeCurrency: Maybe<CMS_SSR_CurrencyChoices>;
  refundedAmount: Scalars['Float'];
  taxRate: Scalars['Float'];
  userEmail: Maybe<Scalars['String']>;
  usesCurrencyConversion: Scalars['Boolean'];
  usesNativeCurrency: Scalars['Boolean'];
};

export type CMS_SSR_CartTierInterface = {
  __typename: 'CMS_SSR_CartTierInterface';
  contractDetails: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  licenceSubject: Maybe<Scalars['String']>;
  tier: CMS_SSR_TierInterface;
};

export type CMS_SSR_CharBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_CharBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_ChoiceBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ChoiceBlock';
  blockType: Scalars['String'];
  choices: Array<CMS_SSR_ChoiceOption>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_ChoiceOption = {
  __typename: 'CMS_SSR_ChoiceOption';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_CollectionObjectType = {
  __typename: 'CMS_SSR_CollectionObjectType';
  ancestors: Array<Maybe<CMS_SSR_CollectionObjectType>>;
  depth: Scalars['Int'];
  descendants: Array<Maybe<CMS_SSR_CollectionObjectType>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  numchild: Scalars['Int'];
  path: Scalars['String'];
};

export type CMS_SSR_ColorSchemeInterface = {
  __typename: 'CMS_SSR_ColorSchemeInterface';
  colorBackground: Scalars['String'];
  colorBackgroundAlt: Maybe<Scalars['String']>;
  colorForeground: Scalars['String'];
  colorForegroundAlt: Maybe<Scalars['String']>;
  colorHighlight: Scalars['String'];
  colorHighlightAlt: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type CMS_SSR_ConfigInterface = {
  __typename: 'CMS_SSR_ConfigInterface';
  awardPageIntro: Scalars['String'];
  baseCurrency: CMS_SSR_CurrencyChoices;
  bigSpecimenRefFontSizePx: Scalars['Int'];
  buildDateTime: Scalars['CMS_SSR_DateTime'];
  businessName: Scalars['String'];
  businessUrl: Scalars['String'];
  countries: Array<CMS_SSR_CountryInterface>;
  crossLicenceDiscountPercentage: Scalars['Float'];
  customOpentypeHtmlTagNames: Array<Scalars['String']>;
  emailSupport: Scalars['String'];
  eulas: Array<CMS_SSR_EulaInterface>;
  isProductionSite: Scalars['Boolean'];
  licenceTypeShortNames: Array<CMS_SSR_LicenceTypeShortName>;
  openTypeFeatureMetaData: Array<CMS_SSR_OpenTypeFeatureMetaDataInterface>;
  packageDiscountPercentages: Array<CMS_SSR_PackageDiscountPercentage>;
  styleDiscountPercentages: Array<CMS_SSR_StyleDiscountPercentage>;
  unitPriceFontStyle: Scalars['Float'];
  userTestingCheckoutAllowed: Scalars['Boolean'];
  userTestingFontFamilyGroupWhitelist: Array<CMS_SSR_FontFamilyGroupInterface>;
  userTestingHostname: Maybe<Scalars['String']>;
};

export type CMS_SSR_ContentWithFootNotesBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ContentWithFootNotesBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  content: Scalars['String'];
  field: Scalars['String'];
  footNotes: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export enum CMS_SSR_CountryChoices {
  AC = 'AC',
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TA = 'TA',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  XK = 'XK',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW'
}

export type CMS_SSR_CountryInterface = {
  __typename: 'CMS_SSR_CountryInterface';
  code: CMS_SSR_CountryChoices;
  name: Scalars['String'];
  taxId: Maybe<Scalars['String']>;
};

export type CMS_SSR_CssRenderInfo = {
  __typename: 'CMS_SSR_CssRenderInfo';
  fontFamilyName: Scalars['String'];
  isItalic: Scalars['Boolean'];
  variableAxisValues: Maybe<Array<CMS_SSR_FontVariationInstanceAxisValueInterface>>;
};

export enum CMS_SSR_CurrencyChoices {
  AUD = 'AUD',
  CAD = 'CAD',
  CHF = 'CHF',
  CNY = 'CNY',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  NOK = 'NOK',
  NZD = 'NZD',
  SEK = 'SEK',
  USD = 'USD'
}

export type CMS_SSR_CustomFontFamilyInterface = {
  __typename: 'CMS_SSR_CustomFontFamilyInterface';
  id: Scalars['ID'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  styles: Array<CMS_SSR_CustomFontStyleInterface>;
  svg: Maybe<Scalars['String']>;
};

export type CMS_SSR_CustomFontImageInterface = {
  __typename: 'CMS_SSR_CustomFontImageInterface';
  feature: Scalars['Boolean'];
  id: Scalars['ID'];
  image: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type CMS_SSR_CustomFontInterface = {
  __typename: 'CMS_SSR_CustomFontInterface';
  awards: Array<CMS_SSR_AwardInterface>;
  bitmapHeading: Maybe<Scalars['String']>;
  colorBackground: Scalars['String'];
  colorForeground: Scalars['String'];
  colorHighlight: Scalars['String'];
  creditAgency: Array<Scalars['String']>;
  creditClient: Array<Scalars['String']>;
  creditCollaborators: Array<Scalars['String']>;
  creditDesign: Array<Scalars['String']>;
  designInformationPage: Maybe<CMS_SSR_BlogPage>;
  families: Array<CMS_SSR_CustomFontFamilyInterface>;
  id: Scalars['ID'];
  images: Array<CMS_SSR_CustomFontImageInterface>;
  informationIntro: Maybe<Scalars['String']>;
  isPreRelease: Scalars['Boolean'];
  name: Scalars['String'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoTitle: Scalars['String'];
  slug: Maybe<Scalars['String']>;
  specimens: Array<CMS_SSR_CustomFontSpecimenInterface>;
  styles: Array<CMS_SSR_CustomFontStyleInterface>;
  svgHeading: Maybe<Scalars['String']>;
  svgNavigation: Maybe<Scalars['String']>;
};

export type CMS_SSR_CustomFontSpecimenInterface = {
  __typename: 'CMS_SSR_CustomFontSpecimenInterface';
  bitmap: Maybe<Scalars['String']>;
  family: Maybe<CMS_SSR_CustomFontFamilyInterface>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  svg: Maybe<Scalars['String']>;
};

export type CMS_SSR_CustomFontStyleInterface = {
  __typename: 'CMS_SSR_CustomFontStyleInterface';
  family: Maybe<CMS_SSR_CustomFontFamilyInterface>;
  id: Scalars['ID'];
  name: Scalars['String'];
  svg: Scalars['String'];
  weight: Scalars['Int'];
};

export type CMS_SSR_CustomImage = {
  __typename: 'CMS_SSR_CustomImage';
  aspectRatio: Scalars['Float'];
  collection: CMS_SSR_CollectionObjectType;
  createdAt: Scalars['CMS_SSR_DateTime'];
  file: Scalars['String'];
  fileHash: Scalars['String'];
  fileSize: Maybe<Scalars['Int']>;
  focalPointHeight: Maybe<Scalars['Int']>;
  focalPointWidth: Maybe<Scalars['Int']>;
  focalPointX: Maybe<Scalars['Int']>;
  focalPointY: Maybe<Scalars['Int']>;
  hasAlpha: Maybe<Scalars['Boolean']>;
  height: Scalars['Int'];
  id: Maybe<Scalars['ID']>;
  isSvg: Scalars['Boolean'];
  placeholderColor: Maybe<Scalars['String']>;
  rendition: Maybe<CMS_SSR_CustomRendition>;
  sizes: Scalars['String'];
  /** @deprecated Use the `url` attribute */
  src: Scalars['String'];
  srcSet: Maybe<Scalars['String']>;
  tags: Array<CMS_SSR_TagObjectType>;
  title: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['Int'];
};


export type CMS_SSR_CustomImagerenditionArgs = {
  bgcolor?: InputMaybe<Scalars['String']>;
  fill?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  jpegquality?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['String']>;
  min?: InputMaybe<Scalars['String']>;
  preserveSvg?: InputMaybe<Scalars['Boolean']>;
  webpquality?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type CMS_SSR_CustomImagesrcSetArgs = {
  format?: InputMaybe<Scalars['String']>;
  preserveSvg?: InputMaybe<Scalars['Boolean']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CMS_SSR_CustomRendition = {
  __typename: 'CMS_SSR_CustomRendition';
  alt: Scalars['String'];
  backgroundPositionStyle: Scalars['String'];
  file: Scalars['String'];
  filterSpec: Scalars['String'];
  focalPoint: Maybe<Scalars['String']>;
  focalPointKey: Scalars['String'];
  height: Scalars['Int'];
  id: Maybe<Scalars['ID']>;
  image: CMS_SSR_CustomImage;
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type CMS_SSR_DateBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_DateBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};


export type CMS_SSR_DateBlockvalueArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_DateTimeBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_DateTimeBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};


export type CMS_SSR_DateTimeBlockvalueArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_DecimalBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_DecimalBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Float'];
};

export type CMS_SSR_DesignerLink = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_DesignerLink';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

export type CMS_SSR_DiscountInterface = {
  __typename: 'CMS_SSR_DiscountInterface';
  amount: Scalars['Float'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  percentage: Scalars['Int'];
  type: CMS_SSR_DiscountType;
};

export enum CMS_SSR_DiscountType {
  PACKAGE = 'PACKAGE',
  STANDARD = 'STANDARD'
}

export type CMS_SSR_DjangoDebug = {
  __typename: 'CMS_SSR_DjangoDebug';
  exceptions: Maybe<Array<Maybe<CMS_SSR_DjangoDebugException>>>;
  sql: Maybe<Array<Maybe<CMS_SSR_DjangoDebugSQL>>>;
};

export type CMS_SSR_DjangoDebugException = {
  __typename: 'CMS_SSR_DjangoDebugException';
  excType: Scalars['String'];
  message: Scalars['String'];
  stack: Scalars['String'];
};

export type CMS_SSR_DjangoDebugSQL = {
  __typename: 'CMS_SSR_DjangoDebugSQL';
  alias: Scalars['String'];
  duration: Scalars['Float'];
  encoding: Maybe<Scalars['String']>;
  isSelect: Scalars['Boolean'];
  isSlow: Scalars['Boolean'];
  isoLevel: Maybe<Scalars['String']>;
  params: Scalars['String'];
  rawSql: Scalars['String'];
  sql: Maybe<Scalars['String']>;
  startTime: Scalars['Float'];
  stopTime: Scalars['Float'];
  transId: Maybe<Scalars['String']>;
  transStatus: Maybe<Scalars['String']>;
  vendor: Scalars['String'];
};

export type CMS_SSR_DocumentChooserBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_DocumentChooserBlock';
  blockType: Scalars['String'];
  document: Maybe<CMS_SSR_DocumentObjectType>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_DocumentObjectType = {
  __typename: 'CMS_SSR_DocumentObjectType';
  collection: CMS_SSR_CollectionObjectType;
  createdAt: Scalars['CMS_SSR_DateTime'];
  file: Scalars['String'];
  fileHash: Scalars['String'];
  fileSize: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  tags: Array<CMS_SSR_TagObjectType>;
  title: Scalars['String'];
  uploadedByUser: Maybe<CMS_SSR_UserInterface>;
  url: Scalars['String'];
};

export type CMS_SSR_EmailBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_EmailBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_EmbedBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_EmbedBlock';
  blockType: Scalars['String'];
  embed: Maybe<Scalars['String']>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawEmbed: Maybe<Scalars['CMS_SSR_JSONString']>;
  rawValue: Scalars['String'];
  url: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_EulaInterface = {
  __typename: 'CMS_SSR_EulaInterface';
  date: Scalars['CMS_SSR_DateTime'];
  introHtml: Array<Scalars['String']>;
  licenceTypeId: CMS_SSR_LicenceTypeId;
  sections: Array<CMS_SSR_EulaSectionInterface>;
  shortName: Scalars['String'];
  title: Scalars['String'];
};

export type CMS_SSR_EulaSectionInterface = {
  __typename: 'CMS_SSR_EulaSectionInterface';
  id: Scalars['String'];
  num: Scalars['Int'];
  subSections: Array<CMS_SSR_EulaSubSectionInterface>;
  title: Scalars['String'];
};

export type CMS_SSR_EulaSubSectionInterface = {
  __typename: 'CMS_SSR_EulaSubSectionInterface';
  contentHtml: Scalars['String'];
  num: Scalars['Int'];
  title: Maybe<Scalars['String']>;
};

export type CMS_SSR_FeaturedImageLinkBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_FeaturedImageLinkBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_FloatBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_FloatBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Float'];
};

export type CMS_SSR_FontFamilyGroupInterface = {
  __typename: 'CMS_SSR_FontFamilyGroupInterface';
  awards: Array<CMS_SSR_AwardInterface>;
  campaign: Maybe<CMS_SSR_CampaignInterface>;
  colorSchemes: Array<CMS_SSR_ColorSchemeInterface>;
  cssRenderInfo: CMS_SSR_CssRenderInfo;
  designInformationPage: Maybe<CMS_SSR_BlogPage>;
  fontFamilies: Array<CMS_SSR_FontFamilyInterface>;
  fontProductType: CMS_SSR_FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleCount: Scalars['Int'];
  fontStyleIdsByFamilyId: Array<CMS_SSR_ProductFontIds>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  informationIntro: Maybe<Scalars['String']>;
  isCollection: Scalars['Boolean'];
  isNew: Scalars['Boolean'];
  name: Scalars['String'];
  pdfSpecimen: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  productSubtitle: Scalars['String'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoTitle: Scalars['String'];
  showInCustomFontMenu: Scalars['Boolean'];
  showOnHomepage: Scalars['Boolean'];
  slug: Scalars['String'];
  svgHeading: Maybe<Scalars['String']>;
  svgNavigation: Maybe<Scalars['String']>;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
};

export type CMS_SSR_FontFamilyInterface = {
  __typename: 'CMS_SSR_FontFamilyInterface';
  awards: Array<CMS_SSR_AwardInterface>;
  campaign: Maybe<CMS_SSR_CampaignInterface>;
  classification: Array<Scalars['String']>;
  creditCollaborators: Array<Scalars['String']>;
  creditDesign: Array<Scalars['String']>;
  creditEngineering: Array<Scalars['String']>;
  cssRenderInfo: CMS_SSR_CssRenderInfo;
  featuredInUsePosts: Maybe<Array<CMS_SSR_PageInterface>>;
  fontFamilyGroup: CMS_SSR_FontFamilyGroupInterface;
  fontProductType: CMS_SSR_FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleCount: Scalars['Int'];
  fontStyleIdsByFamilyId: Array<CMS_SSR_ProductFontIds>;
  fontStyles: Array<CMS_SSR_FontStyleInterface>;
  fullName: Scalars['String'];
  hasVariableFonts: Scalars['Boolean'];
  id: Scalars['ID'];
  isPreRelease: Scalars['Boolean'];
  mainFontStyle: CMS_SSR_FontStyleInterface;
  mainSubfamily: Maybe<CMS_SSR_FontSubfamilyInterface>;
  name: Scalars['String'];
  notableDetails: Array<CMS_SSR_FontFamilyNotableDetailInterface>;
  openTypeFeatures: Array<CMS_SSR_FontOpenTypeFeatureInterface>;
  opentypeSpecimens: Array<CMS_SSR_FontFamilyOpenTypeFeatureInterface>;
  productName: Scalars['String'];
  productSubtitle: Scalars['String'];
  release: Maybe<Scalars['CMS_SSR_Date']>;
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoTitle: Scalars['String'];
  slug: Scalars['String'];
  subfamilies: Array<CMS_SSR_FontSubfamilyInterface>;
  supportedLanguages: Array<Scalars['String']>;
  svgHeading: Maybe<Scalars['String']>;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
  versionNumber: Maybe<Scalars['Float']>;
  vfItalicFiles: Maybe<CMS_SSR_FontFilesInterface>;
  vfRomanFiles: Maybe<CMS_SSR_FontFilesInterface>;
};


export type CMS_SSR_FontFamilyInterfacefeaturedInUsePostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type CMS_SSR_FontFamilyNotableDetailInterface = {
  __typename: 'CMS_SSR_FontFamilyNotableDetailInterface';
  id: Scalars['ID'];
  svg: Scalars['String'];
};

export type CMS_SSR_FontFamilyOpenTypeFeatureInterface = {
  __typename: 'CMS_SSR_FontFamilyOpenTypeFeatureInterface';
  customDescription: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  specimen: CMS_SSR_SpecimenInterface;
  specimenShowAll: Maybe<CMS_SSR_SpecimenInterface>;
  type: CMS_SSR_SpecimenFontFamilyOpenTypeFeatureTypeChoices;
};

export type CMS_SSR_FontFilesInterface = {
  __typename: 'CMS_SSR_FontFilesInterface';
  created: Scalars['CMS_SSR_DateTime'];
  file: Scalars['String'];
  id: Scalars['ID'];
  metrics: CMS_SSR_FontMetricsInterface;
  modified: Scalars['CMS_SSR_DateTime'];
  testFile: Maybe<Scalars['String']>;
  uuid: Scalars['CMS_SSR_UUID'];
  versionNumber: Scalars['CMS_SSR_Decimal'];
  woff2File: Maybe<Scalars['String']>;
  woff2FileSize: Maybe<Scalars['Int']>;
  woff2TestFile: Maybe<Scalars['String']>;
  woffFile: Scalars['String'];
};

export type CMS_SSR_FontMetricsInterface = {
  __typename: 'CMS_SSR_FontMetricsInterface';
  ascentCalc: Scalars['Int'];
  ascentHhea: Scalars['Int'];
  ascentTypoOs2: Scalars['Int'];
  ascentWinOs2: Scalars['Int'];
  capHeightOs2: Scalars['Int'];
  created: Scalars['CMS_SSR_DateTime'];
  descentCalc: Scalars['Int'];
  descentHhea: Scalars['Int'];
  descentTypoOs2: Scalars['Int'];
  descentWinOs2: Scalars['Int'];
  id: Scalars['ID'];
  lineGapHhea: Scalars['Int'];
  lineGapTypoOs2: Scalars['Int'];
  modified: Scalars['CMS_SSR_DateTime'];
  unitsPerEmHead: Scalars['Int'];
  uuid: Scalars['CMS_SSR_UUID'];
  xHeightOs2: Scalars['Int'];
};

export type CMS_SSR_FontOpenTypeFeatureInterface = {
  __typename: 'CMS_SSR_FontOpenTypeFeatureInterface';
  allGlyphs: Maybe<Scalars['String']>;
  created: Scalars['CMS_SSR_DateTime'];
  customAllGlyphs: Maybe<Scalars['String']>;
  customDescription: Maybe<Scalars['String']>;
  customExample: Maybe<Scalars['String']>;
  customLabel: Maybe<Scalars['String']>;
  defaultAllGlyphs: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  example: Maybe<Scalars['String']>;
  fontStyles: Array<CMS_SSR_FontStyleInterface>;
  id: Scalars['ID'];
  label: Maybe<Scalars['String']>;
  loadAsDefault: Scalars['Boolean'];
  modified: Scalars['CMS_SSR_DateTime'];
  secondaryTags: Array<Scalars['String']>;
  tag: Scalars['String'];
  uuid: Scalars['CMS_SSR_UUID'];
};

export type CMS_SSR_FontProductInterface = {
  __typename: 'CMS_SSR_FontProductInterface';
  cssRenderInfo: CMS_SSR_CssRenderInfo;
  fontId: Scalars['ID'];
  fontProductType: CMS_SSR_FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleIdsByFamilyId: Array<CMS_SSR_ProductFontIds>;
  typographicRanking: Maybe<Scalars['Int']>;
};

export enum CMS_SSR_FontProductTypeChoice {
  FONTFAMILY = 'FONTFAMILY',
  FONTFAMILYGROUP = 'FONTFAMILYGROUP',
  FONTSTYLE = 'FONTSTYLE'
}

export type CMS_SSR_FontStyleInterface = {
  __typename: 'CMS_SSR_FontStyleInterface';
  cssRenderInfo: CMS_SSR_CssRenderInfo;
  fontProductType: CMS_SSR_FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleCount: Scalars['Int'];
  fontStyleIdsByFamilyId: Array<CMS_SSR_ProductFontIds>;
  fontSubfamily: Maybe<CMS_SSR_FontSubfamilyInterface>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  openTypeFeatures: Array<CMS_SSR_FontOpenTypeFeatureInterface>;
  otfFiles: Maybe<CMS_SSR_FontFilesInterface>;
  pixelSize: Maybe<Scalars['Int']>;
  pointSize: Maybe<Scalars['Float']>;
  productName: Scalars['String'];
  productSubtitle: Scalars['String'];
  ttfFiles: Maybe<CMS_SSR_FontFilesInterface>;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
  weight: Scalars['Int'];
};

export type CMS_SSR_FontStyleWithCorrespondingStyles = {
  __typename: 'CMS_SSR_FontStyleWithCorrespondingStyles';
  boldStyleId: Maybe<Scalars['String']>;
  cssRenderInfo: CMS_SSR_CssRenderInfo;
  fontMetrics: Maybe<CMS_SSR_FontMetricsInterface>;
  id: Scalars['ID'];
  italicStyleId: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pixelSize: Maybe<Scalars['Int']>;
  variableAxes: Maybe<Array<Maybe<CMS_SSR_FontVariationAxisInterface>>>;
  weight: Scalars['Int'];
};

export type CMS_SSR_FontStyleWithWords = {
  __typename: 'CMS_SSR_FontStyleWithWords';
  cssRenderInfo: CMS_SSR_CssRenderInfo;
  fontMetrics: Maybe<CMS_SSR_FontMetricsInterface>;
  id: Scalars['ID'];
  isItalic: Scalars['Boolean'];
  name: Scalars['String'];
  variableAxes: Maybe<Array<Maybe<CMS_SSR_FontVariationAxisInterface>>>;
  weight: Scalars['Int'];
  words: Array<CMS_SSR_SpecimenWord>;
};

export type CMS_SSR_FontSubfamilyInterface = {
  __typename: 'CMS_SSR_FontSubfamilyInterface';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CMS_SSR_FontVariationAxisInterface = {
  __typename: 'CMS_SSR_FontVariationAxisInterface';
  created: Scalars['CMS_SSR_DateTime'];
  defaultValue: Scalars['Float'];
  id: Scalars['ID'];
  maxValue: Scalars['Float'];
  minValue: Scalars['Float'];
  modified: Scalars['CMS_SSR_DateTime'];
  name: Scalars['String'];
  tag: Scalars['String'];
  uuid: Scalars['CMS_SSR_UUID'];
};

export type CMS_SSR_FontVariationInstanceAxisValueInterface = {
  __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface';
  tag: Scalars['String'];
  value: Scalars['Float'];
};

export type CMS_SSR_FontsInUseDetailPage = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_FontsInUseDetailPage';
  aliasOf: Maybe<CMS_SSR_Page>;
  aliases: Array<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  blogindexpage: Maybe<CMS_SSR_BlogIndexPage>;
  blogpage: Maybe<CMS_SSR_BlogPage>;
  blurbImage: CMS_SSR_CustomImage;
  body: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  categories: Maybe<Array<CMS_SSR_FontsInUseDetailPageMediaTag>>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  designerLinks: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  feedImage: Maybe<CMS_SSR_CustomImage>;
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  fontFamilies: Maybe<Array<CMS_SSR_FontFamilyInterface>>;
  fontsinusedetailpage: Maybe<CMS_SSR_FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<CMS_SSR_FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<CMS_SSR_HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  mediaCount: Scalars['Int'];
  nextSiblings: Array<CMS_SSR_PageInterface>;
  noindex: Scalars['Boolean'];
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  postDate: Scalars['CMS_SSR_DateTime'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  sitesRootedHere: Array<CMS_SSR_SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_FontsInUseDetailPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagecategoriesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_FontsInUseDetailPageFontFamily = {
  __typename: 'CMS_SSR_FontsInUseDetailPageFontFamily';
  id: Maybe<Scalars['ID']>;
};

export type CMS_SSR_FontsInUseDetailPageMediaTag = {
  __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag';
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type CMS_SSR_FontsInUseIndexPage = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_FontsInUseIndexPage';
  aliasOf: Maybe<CMS_SSR_Page>;
  aliases: Array<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  blogindexpage: Maybe<CMS_SSR_BlogIndexPage>;
  blogpage: Maybe<CMS_SSR_BlogPage>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  fontsinusedetailpage: Maybe<CMS_SSR_FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<CMS_SSR_FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<CMS_SSR_HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  sitesRootedHere: Array<CMS_SSR_SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_FontsInUseIndexPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseIndexPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseIndexPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseIndexPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseIndexPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseIndexPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export enum CMS_SSR_FontsSpecimenConfigLetterCaseChoices {
  LOWER_CASE = 'LOWER_CASE',
  SENTENCE_CASE = 'SENTENCE_CASE',
  TITLE_CASE = 'TITLE_CASE',
  UNALTERED = 'UNALTERED',
  UPPER_CASE = 'UPPER_CASE'
}

export enum CMS_SSR_FontsSpecimenConfigSpecimenTypeChoices {
  BIG = 'BIG',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export type CMS_SSR_HeadingBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_HeadingBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  title: Scalars['String'];
};

export type CMS_SSR_HeroVideoAndImageBlocks = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_HeroVideoAndImageBlocks';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_HomePage = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_HomePage';
  aliasOf: Maybe<CMS_SSR_Page>;
  aliases: Array<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  blogindexpage: Maybe<CMS_SSR_BlogIndexPage>;
  blogpage: Maybe<CMS_SSR_BlogPage>;
  campaigns: Maybe<Array<CMS_SSR_HomePageCampaign>>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  featuredBlogPosts: Maybe<Array<Maybe<CMS_SSR_BlogPage>>>;
  featuredFonts: Maybe<Array<CMS_SSR_FontFamilyGroupInterface>>;
  featuredInUsePosts: Maybe<Array<Maybe<CMS_SSR_FontsInUseDetailPage>>>;
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  fontsinusedetailpage: Maybe<CMS_SSR_FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<CMS_SSR_FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<CMS_SSR_HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  sitesRootedHere: Array<CMS_SSR_SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_HomePageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagecampaignsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagefeaturedBlogPostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagefeaturedInUsePostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_HomePageCampaign = {
  __typename: 'CMS_SSR_HomePageCampaign';
  campaign: CMS_SSR_CampaignInterface;
  fontFamilyGroup: CMS_SSR_FontFamilyGroupInterface;
  id: Maybe<Scalars['ID']>;
  sortOrder: Maybe<Scalars['Int']>;
};

export type CMS_SSR_HomepageCampaignBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_HomepageCampaignBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  fontFamilyGroup: Maybe<CMS_SSR_FontFamilyGroupInterface>;
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export enum CMS_SSR_HyperlinkColorChoice {
  DARK = 'DARK',
  LIGHT = 'LIGHT'
}

export type CMS_SSR_HyperlinkedBaseBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_HyperlinkedBaseBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  linkText: Maybe<Scalars['String']>;
  linkTextColor: CMS_SSR_HyperlinkColorChoice;
  rawValue: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

export type CMS_SSR_ImageBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ImageBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  caption: Maybe<Scalars['String']>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  image: Maybe<CMS_SSR_CustomImage>;
  rawValue: Scalars['String'];
  svg: Maybe<CMS_SSR_DocumentObjectType>;
};

export type CMS_SSR_ImageChooserBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ImageChooserBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  image: Maybe<CMS_SSR_CustomImage>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_ImageSectionBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ImageSectionBlock';
  background: Maybe<Scalars['Boolean']>;
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  colorBackground: Maybe<Scalars['String']>;
  colorCaption: Maybe<Scalars['String']>;
  content: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  field: Scalars['String'];
  heading: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  noVerticalMargins: Maybe<Scalars['Boolean']>;
  rawValue: Scalars['String'];
  singleImageLayout: CMS_SSR_SingleImageLayoutChoice;
};

export type CMS_SSR_ImageWithPortraitBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ImageWithPortraitBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  landscapeImage: Maybe<CMS_SSR_CustomImage>;
  landscapeSvg: Maybe<CMS_SSR_DocumentObjectType>;
  portraitImage: Maybe<CMS_SSR_CustomImage>;
  portraitSvg: Maybe<CMS_SSR_DocumentObjectType>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_IntegerBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_IntegerBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Int'];
};

export type CMS_SSR_InvoiceInterface = {
  __typename: 'CMS_SSR_InvoiceInterface';
  id: Scalars['ID'];
};

export enum CMS_SSR_KlimcartOrderStatusChoices {
  DELIVERED = 'DELIVERED',
  NEW = 'NEW'
}

export enum CMS_SSR_KlimcartOrderUpgradeRequestStatusChoices {
  COMPLETE = 'COMPLETE',
  INVOICED = 'INVOICED',
  NEW = 'NEW'
}

export enum CMS_SSR_LicenceTypeId {
  AD = 'AD',
  APP = 'APP',
  BROADCAST = 'BROADCAST',
  DESKTOP = 'DESKTOP',
  OEM = 'OEM',
  TEST = 'TEST',
  UDLA = 'UDLA',
  WEB = 'WEB'
}

export type CMS_SSR_LicenceTypeInterface = {
  __typename: 'CMS_SSR_LicenceTypeInterface';
  contractDetailsLabel: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isAvailableViaCart: Scalars['Boolean'];
  licenceSubjectLabel: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tieredLicensing: Array<CMS_SSR_TieredLicensingInterface>;
};

export enum CMS_SSR_LicenceTypeShortName {
  Advertising = 'Advertising',
  App = 'App',
  Broadcasting = 'Broadcasting',
  Desktop = 'Desktop',
  Enterprise = 'Enterprise',
  OEM = 'OEM',
  Test = 'Test',
  Web = 'Web'
}

export type CMS_SSR_LineItemInterface = {
  __typename: 'CMS_SSR_LineItemInterface';
  description: Maybe<Scalars['String']>;
  font: Maybe<CMS_SSR_FontProductInterface>;
  fontLicenceType: Maybe<CMS_SSR_LicenceTypeInterface>;
  fontSizeMultiplier: Scalars['Float'];
  id: Scalars['ID'];
  isRefunded: Scalars['Boolean'];
  price: Scalars['Float'];
  productName: Maybe<Scalars['String']>;
  productSubtitle: Maybe<Scalars['String']>;
  type: CMS_SSR_LineItemType;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
  upgradedOrderNumbers: Array<Scalars['String']>;
};

export enum CMS_SSR_LineItemType {
  CUSTOM = 'CUSTOM',
  GOODS = 'GOODS',
  OTHER = 'OTHER',
  RETAIL = 'RETAIL',
  UPGRADE = 'UPGRADE'
}

export type CMS_SSR_ListBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ListBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  items: Array<CMS_SSR_StreamFieldInterface>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_MediumSpecimenSet = {
  __typename: 'CMS_SSR_MediumSpecimenSet';
  fixedOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  fontSize: Scalars['Float'];
  fontStyles: Array<CMS_SSR_FontStyleWithCorrespondingStyles>;
  letterSpacing: Scalars['Float'];
  lineHeight: Scalars['Float'];
  randomOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  randomOpentypeLikelihood: Scalars['Int'];
  sentences: Array<Scalars['String']>;
  specimensPerFontStyle: Scalars['Int'];
};

export type CMS_SSR_OpenTypeFeatureMetaDataInterface = {
  __typename: 'CMS_SSR_OpenTypeFeatureMetaDataInterface';
  defaultAllGlyphs: Maybe<Scalars['String']>;
  defaultDescription: Maybe<Scalars['String']>;
  defaultExample: Maybe<Scalars['String']>;
  defaultLabel: Scalars['String'];
  tag: Scalars['String'];
};

export type CMS_SSR_OrderInterface = {
  __typename: 'CMS_SSR_OrderInterface';
  account: CMS_SSR_AccountInterface;
  activeUpgradeRequest: Maybe<CMS_SSR_OrderUpgradeRequestInterface>;
  cart: CMS_SSR_CartInterface;
  date: Scalars['CMS_SSR_DateTime'];
  downloadFilename: Maybe<Scalars['String']>;
  downloadHasUpdate: Maybe<Scalars['Boolean']>;
  downloadLastModified: Maybe<Scalars['CMS_SSR_DateTime']>;
  downloadUrl: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceUrl: Maybe<Scalars['String']>;
  orderNumber: Scalars['String'];
  status: CMS_SSR_KlimcartOrderStatusChoices;
  storageDownloadUrl: Maybe<Scalars['String']>;
};

export type CMS_SSR_OrderUpgradeRequestInterface = {
  __typename: 'CMS_SSR_OrderUpgradeRequestInterface';
  details: Scalars['String'];
  id: Scalars['ID'];
  invoice: Maybe<CMS_SSR_InvoiceInterface>;
  licenceAppName: Maybe<Scalars['String']>;
  licenceWebDomainName: Maybe<Scalars['String']>;
  status: CMS_SSR_KlimcartOrderUpgradeRequestStatusChoices;
};

export type CMS_SSR_PackageDiscountPercentage = {
  __typename: 'CMS_SSR_PackageDiscountPercentage';
  discount: Scalars['Float'];
  fontProductType: CMS_SSR_FontProductTypeChoice;
};

export type CMS_SSR_Page = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_Page';
  aliasOf: Maybe<CMS_SSR_Page>;
  aliases: Array<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  blogindexpage: Maybe<CMS_SSR_BlogIndexPage>;
  blogpage: Maybe<CMS_SSR_BlogPage>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  fontsinusedetailpage: Maybe<CMS_SSR_FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<CMS_SSR_FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<CMS_SSR_HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  sitesRootedHere: Array<CMS_SSR_SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_PageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_PageChooserBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_PageChooserBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  page: Maybe<CMS_SSR_PageInterface>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_PageInterface = {
  ancestors: Array<CMS_SSR_PageInterface>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_PageInterfaceancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PageInterfacechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PageInterfacedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PageInterfacenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PageInterfacepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PageInterfacesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_PreviewSpecimenSet = {
  __typename: 'CMS_SSR_PreviewSpecimenSet';
  bigSpecimenSet: Maybe<CMS_SSR_BigSpecimenSet>;
  canBeProcessed: Scalars['Boolean'];
  characterCount: Scalars['Int'];
  characterCountTolerance: Scalars['Int'];
  columns: Scalars['Int'];
  columnsSecondary: Scalars['Int'];
  created: Scalars['CMS_SSR_DateTime'];
  fixedOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  fontFamily: CMS_SSR_FontFamilyInterface;
  fontSize: Scalars['CMS_SSR_Decimal'];
  fontSizeSecondary: Scalars['CMS_SSR_Decimal'];
  fontStyles: Array<CMS_SSR_FontStyleWithCorrespondingStyles>;
  hasWordsToBeProcessed: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isProcessed: Scalars['Boolean'];
  isProcessing: Scalars['Boolean'];
  letterCase: CMS_SSR_FontsSpecimenConfigLetterCaseChoices;
  letterSpacing: Scalars['CMS_SSR_Decimal'];
  lineCount: Scalars['Int'];
  lineCountSecondary: Scalars['Int'];
  lineHeight: Scalars['CMS_SSR_Decimal'];
  maxProcessedWords: Scalars['Int'];
  mediumSpecimenSet: Maybe<CMS_SSR_MediumSpecimenSet>;
  modified: Scalars['CMS_SSR_DateTime'];
  processedWords: Array<CMS_SSR_SpecimenWord>;
  randomOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  randomOpentypeLikelihood: Scalars['Int'];
  referenceWord: Scalars['String'];
  referenceWordCalculatedWidth: Maybe<Scalars['Int']>;
  referenceWordFontStyle: Maybe<CMS_SSR_FontStyleWithCorrespondingStyles>;
  smallSpecimenSet: Maybe<CMS_SSR_SmallSpecimenSet>;
  specimenType: CMS_SSR_FontsSpecimenConfigSpecimenTypeChoices;
  specimensPerFontStyle: Scalars['Int'];
  uuid: Scalars['CMS_SSR_UUID'];
  widthTolerance: Scalars['CMS_SSR_Decimal'];
  wordsInSmallCaps: Scalars['Int'];
};

export type CMS_SSR_ProductFontIds = {
  __typename: 'CMS_SSR_ProductFontIds';
  fontFamilyId: Scalars['ID'];
  fontStyleIds: Array<Scalars['ID']>;
};

export type CMS_SSR_QuestionAndAnswerBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_QuestionAndAnswerBlock';
  answer: Scalars['String'];
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  question: Scalars['String'];
  rawValue: Scalars['String'];
};

export type CMS_SSR_QuoteBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_QuoteBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  caption: Maybe<Scalars['String']>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  quote: Scalars['String'];
  rawValue: Scalars['String'];
};

export type CMS_SSR_RawHTMLBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_RawHTMLBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_Redirect = {
  __typename: 'CMS_SSR_Redirect';
  isPermanent: Scalars['Boolean'];
  newUrl: Maybe<Scalars['String']>;
  oldPath: Scalars['String'];
  oldUrl: Scalars['String'];
  page: Maybe<CMS_SSR_PageInterface>;
  site: CMS_SSR_SiteObjectType;
};

export type CMS_SSR_RegexBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_RegexBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_RichTextBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_RichTextBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_Search = CMS_SSR_BlogIndexPage | CMS_SSR_BlogPage | CMS_SSR_BlogPostFeaturedFont | CMS_SSR_BlogTag | CMS_SSR_CustomImage | CMS_SSR_CustomRendition | CMS_SSR_FontsInUseDetailPage | CMS_SSR_FontsInUseDetailPageFontFamily | CMS_SSR_FontsInUseDetailPageMediaTag | CMS_SSR_FontsInUseIndexPage | CMS_SSR_HomePage | CMS_SSR_HomePageCampaign | CMS_SSR_Page | CMS_SSR_SiteConfiguration | CMS_SSR_TaggedBlogBase;

export type CMS_SSR_SimpleHyperlinkedImageBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  image: CMS_SSR_CustomImage;
  linkText: Scalars['String'];
  rawValue: Scalars['String'];
  title: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CMS_SSR_SimpleImageBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_SimpleImageBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  image: Maybe<CMS_SSR_CustomImage>;
  rawValue: Scalars['String'];
  svg: Maybe<CMS_SSR_DocumentObjectType>;
};

export type CMS_SSR_SimpleImageSectionBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_SimpleImageSectionBlock';
  background: Maybe<Scalars['Boolean']>;
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  colorBackground: Maybe<Scalars['String']>;
  content: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  noVerticalMargins: Maybe<Scalars['Boolean']>;
  rawValue: Scalars['String'];
  singleImageLayout: CMS_SSR_SingleImageLayoutChoice;
};

export type CMS_SSR_SimpleVideoBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_SimpleVideoBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  video: Scalars['String'];
  videoAspectRatio: Maybe<Scalars['String']>;
};

export type CMS_SSR_SimpleVideoCaptionBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_SimpleVideoCaptionBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  caption: Maybe<Scalars['String']>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  video: Scalars['String'];
  videoAspectRatio: Maybe<Scalars['String']>;
};

export enum CMS_SSR_SingleImageLayoutChoice {
  fullwidth = 'fullwidth',
  inline = 'inline',
  medium = 'medium'
}

export type CMS_SSR_SiteConfiguration = {
  __typename: 'CMS_SSR_SiteConfiguration';
  id: Maybe<Scalars['ID']>;
};

export type CMS_SSR_SiteObjectType = {
  __typename: 'CMS_SSR_SiteObjectType';
  hostname: Scalars['String'];
  id: Scalars['ID'];
  isDefaultSite: Scalars['Boolean'];
  page: Maybe<CMS_SSR_PageInterface>;
  pages: Array<CMS_SSR_PageInterface>;
  port: Scalars['Int'];
  rootPage: CMS_SSR_Page;
  siteName: Scalars['String'];
};


export type CMS_SSR_SiteObjectTypepageArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_SiteObjectTypepagesArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_SmallSpecimenSet = {
  __typename: 'CMS_SSR_SmallSpecimenSet';
  characterCount: Scalars['Int'];
  columns: Scalars['Int'];
  columnsSecondary: Scalars['Int'];
  fixedOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  fontSize: Scalars['Float'];
  fontSizeSecondary: Scalars['Float'];
  fontStyles: Array<CMS_SSR_FontStyleWithCorrespondingStyles>;
  letterSpacing: Scalars['Float'];
  lineCount: Scalars['Int'];
  lineCountSecondary: Scalars['Int'];
  lineHeight: Scalars['Float'];
  randomOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  randomOpentypeLikelihood: Scalars['Int'];
  sentences: Array<Scalars['String']>;
  wordsInSmallCaps: Scalars['Int'];
};

export enum CMS_SSR_SpecimenFontFamilyOpenTypeFeatureTypeChoices {
  C2SC = 'C2SC',
  CASE = 'CASE',
  DLIG = 'DLIG',
  FRAC = 'FRAC',
  ORDN = 'ORDN',
  PNUM_LNUM = 'PNUM_LNUM',
  PNUM_ONUM = 'PNUM_ONUM',
  SINF = 'SINF',
  SSXX = 'SSXX',
  SUPS = 'SUPS',
  SWSH = 'SWSH',
  TNUM_LNUM = 'TNUM_LNUM',
  TNUM_ONUM = 'TNUM_ONUM',
  ZERO = 'ZERO'
}

export type CMS_SSR_SpecimenInterface = {
  __typename: 'CMS_SSR_SpecimenInterface';
  columns: Scalars['Int'];
  cssRenderInfo: Maybe<CMS_SSR_CssRenderInfo>;
  fontSize: Scalars['CMS_SSR_Decimal'];
  fontStyleName: Scalars['String'];
  id: Scalars['ID'];
  letterSpacing: Scalars['CMS_SSR_Decimal'];
  lineHeight: Scalars['CMS_SSR_Decimal'];
  specimenType: Maybe<CMS_SSR_SpecimenTypeChoice>;
  state: Scalars['String'];
  textAlign: Scalars['String'];
};

export enum CMS_SSR_SpecimenTypeChoice {
  BIG = 'BIG',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export type CMS_SSR_SpecimenWord = {
  __typename: 'CMS_SSR_SpecimenWord';
  content: Scalars['String'];
  contentAscii: Scalars['String'];
  opentypeFeatures: Maybe<Array<Scalars['String']>>;
  width: Scalars['Int'];
};

export type CMS_SSR_StaticBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_StaticBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_StreamBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_StreamBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_StreamFieldBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_StreamFieldBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_StreamFieldInterface = {
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_StructBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_StructBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_StyleDiscountPercentage = {
  __typename: 'CMS_SSR_StyleDiscountPercentage';
  discount: Scalars['Float'];
  quantity: Scalars['Int'];
};

export type CMS_SSR_TagInterface = {
  __typename: 'CMS_SSR_TagInterface';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type CMS_SSR_TagObjectType = {
  __typename: 'CMS_SSR_TagObjectType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CMS_SSR_TaggedBlogBase = {
  __typename: 'CMS_SSR_TaggedBlogBase';
  id: Maybe<Scalars['ID']>;
};

export type CMS_SSR_TestFontsInterface = {
  __typename: 'CMS_SSR_TestFontsInterface';
  allFontsArchiveFilesize: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
};

export type CMS_SSR_TextBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_TextBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_TierInterface = {
  __typename: 'CMS_SSR_TierInterface';
  amount: Scalars['String'];
  hasContractDetailsField: Scalars['Boolean'];
  hasLicenceSubjectField: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isUnlimited: Scalars['Boolean'];
  licenceType: CMS_SSR_LicenceTypeInterface;
  multiplier: Scalars['Float'];
  tieredLicence: CMS_SSR_TieredLicensingInterface;
  title: Scalars['String'];
  titleAbbrev: Scalars['String'];
};

export type CMS_SSR_TieredLicensingInterface = {
  __typename: 'CMS_SSR_TieredLicensingInterface';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  licenceType: CMS_SSR_LicenceTypeInterface;
  tiers: Array<CMS_SSR_TierInterface>;
  title: Scalars['String'];
  unitStr: Scalars['String'];
  unitStrAbbrev: Scalars['String'];
  unitStrAbbrevPlural: Scalars['String'];
  unitStrPlural: Scalars['String'];
};

export type CMS_SSR_TimeBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_TimeBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};


export type CMS_SSR_TimeBlockvalueArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_URLBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_URLBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_UserInterface = {
  __typename: 'CMS_SSR_UserInterface';
  billingAddress1: Maybe<Scalars['String']>;
  billingAddress2: Maybe<Scalars['String']>;
  billingCity: Maybe<Scalars['String']>;
  billingCompanyName: Maybe<Scalars['String']>;
  billingCountry: Maybe<CMS_SSR_CountryChoices>;
  billingPostcode: Maybe<Scalars['String']>;
  billingState: Maybe<Scalars['String']>;
  billingVatNumber: Maybe<Scalars['String']>;
  canRevert: Scalars['Boolean'];
  email: Scalars['String'];
  emailOptIn: Scalars['Boolean'];
  fullName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  orders: Array<CMS_SSR_OrderInterface>;
};


export type CMS_SSR_UserInterfaceordersArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type CMS_SSR_VideoBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_VideoBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  caption: Maybe<Scalars['String']>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  posterImage: Maybe<CMS_SSR_CustomImage>;
  rawValue: Scalars['String'];
  thumbnailUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  video: Scalars['String'];
  videoAspectRatio: Maybe<Scalars['String']>;
};

export type CMS_SSR_VimeoVideoFileInterface = {
  __typename: 'CMS_SSR_VimeoVideoFileInterface';
  height: Scalars['Int'];
  id: Scalars['ID'];
  src: Scalars['String'];
  type: Scalars['String'];
  video: CMS_SSR_VimeoVideoInterface;
  width: Scalars['Int'];
};

export type CMS_SSR_VimeoVideoInterface = {
  __typename: 'CMS_SSR_VimeoVideoInterface';
  embedUrl: Scalars['String'];
  files: Array<CMS_SSR_VimeoVideoFileInterface>;
  height: Scalars['Int'];
  id: Scalars['ID'];
  title: Scalars['String'];
  width: Scalars['Int'];
};

export type DateQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type Directory = Node & {
  __typename: 'Directory';
  absolutePath: Scalars['String'];
  accessTime: Scalars['Date'];
  atime: Scalars['Date'];
  atimeMs: Scalars['Float'];
  base: Scalars['String'];
  birthTime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs: Maybe<Scalars['Float']>;
  changeTime: Scalars['Date'];
  children: Array<Node>;
  ctime: Scalars['Date'];
  ctimeMs: Scalars['Float'];
  dev: Scalars['Int'];
  dir: Scalars['String'];
  ext: Scalars['String'];
  extension: Scalars['String'];
  gid: Scalars['Int'];
  id: Scalars['ID'];
  ino: Scalars['Float'];
  internal: Internal;
  mode: Scalars['Int'];
  modifiedTime: Scalars['Date'];
  mtime: Scalars['Date'];
  mtimeMs: Scalars['Float'];
  name: Scalars['String'];
  nlink: Scalars['Int'];
  parent: Maybe<Node>;
  prettySize: Scalars['String'];
  rdev: Scalars['Int'];
  relativeDirectory: Scalars['String'];
  relativePath: Scalars['String'];
  root: Scalars['String'];
  size: Scalars['Int'];
  sourceInstanceName: Scalars['String'];
  uid: Scalars['Int'];
};


export type DirectoryaccessTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryatimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectorybirthTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectorychangeTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryctimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectorymodifiedTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectorymtimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type DirectoryConnection = {
  __typename: 'DirectoryConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<DirectoryEdge>;
  group: Array<DirectoryGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type DirectoryConnectiondistinctArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectiongroupArgs = {
  field: DirectoryFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type DirectoryConnectionmaxArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectionminArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectionsumArgs = {
  field: DirectoryFieldsEnum;
};

export type DirectoryEdge = {
  __typename: 'DirectoryEdge';
  next: Maybe<Directory>;
  node: Directory;
  previous: Maybe<Directory>;
};

export enum DirectoryFieldsEnum {
  absolutePath = 'absolutePath',
  accessTime = 'accessTime',
  atime = 'atime',
  atimeMs = 'atimeMs',
  base = 'base',
  birthTime = 'birthTime',
  birthtime = 'birthtime',
  birthtimeMs = 'birthtimeMs',
  changeTime = 'changeTime',
  children = 'children',
  children___children = 'children___children',
  children___children___children = 'children___children___children',
  children___children___children___children = 'children___children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___id = 'children___children___id',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___contentFilePath = 'children___children___internal___contentFilePath',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___children___parent___children = 'children___children___parent___children',
  children___children___parent___id = 'children___children___parent___id',
  children___id = 'children___id',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___contentFilePath = 'children___internal___contentFilePath',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  children___parent___children = 'children___parent___children',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___id = 'children___parent___id',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___contentFilePath = 'children___parent___internal___contentFilePath',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___parent___id = 'children___parent___parent___id',
  ctime = 'ctime',
  ctimeMs = 'ctimeMs',
  dev = 'dev',
  dir = 'dir',
  ext = 'ext',
  extension = 'extension',
  gid = 'gid',
  id = 'id',
  ino = 'ino',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___contentFilePath = 'internal___contentFilePath',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  mode = 'mode',
  modifiedTime = 'modifiedTime',
  mtime = 'mtime',
  mtimeMs = 'mtimeMs',
  name = 'name',
  nlink = 'nlink',
  parent___children = 'parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___id = 'parent___children___id',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___contentFilePath = 'parent___children___internal___contentFilePath',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___id = 'parent___id',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___contentFilePath = 'parent___internal___contentFilePath',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___contentFilePath = 'parent___parent___internal___contentFilePath',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___parent___id = 'parent___parent___parent___id',
  prettySize = 'prettySize',
  rdev = 'rdev',
  relativeDirectory = 'relativeDirectory',
  relativePath = 'relativePath',
  root = 'root',
  size = 'size',
  sourceInstanceName = 'sourceInstanceName',
  uid = 'uid'
}

export type DirectoryFilterInput = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};

export type DirectoryGroupConnection = {
  __typename: 'DirectoryGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<DirectoryEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<DirectoryGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type DirectoryGroupConnectiondistinctArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryGroupConnectiongroupArgs = {
  field: DirectoryFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type DirectoryGroupConnectionmaxArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryGroupConnectionminArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryGroupConnectionsumArgs = {
  field: DirectoryFieldsEnum;
};

export type DirectorySortInput = {
  fields?: InputMaybe<Array<InputMaybe<DirectoryFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type File = Node & {
  __typename: 'File';
  absolutePath: Scalars['String'];
  accessTime: Scalars['Date'];
  atime: Scalars['Date'];
  atimeMs: Scalars['Float'];
  base: Scalars['String'];
  birthTime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs: Maybe<Scalars['Float']>;
  changeTime: Scalars['Date'];
  children: Array<Node>;
  ctime: Scalars['Date'];
  ctimeMs: Scalars['Float'];
  dev: Scalars['Int'];
  dir: Scalars['String'];
  ext: Scalars['String'];
  extension: Scalars['String'];
  gid: Scalars['Int'];
  id: Scalars['ID'];
  ino: Scalars['Float'];
  internal: Internal;
  mode: Scalars['Int'];
  modifiedTime: Scalars['Date'];
  mtime: Scalars['Date'];
  mtimeMs: Scalars['Float'];
  name: Scalars['String'];
  nlink: Scalars['Int'];
  parent: Maybe<Node>;
  prettySize: Scalars['String'];
  rdev: Scalars['Int'];
  relativeDirectory: Scalars['String'];
  relativePath: Scalars['String'];
  root: Scalars['String'];
  size: Scalars['Int'];
  sourceInstanceName: Scalars['String'];
  uid: Scalars['Int'];
};


export type FileaccessTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileatimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FilebirthTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FilechangeTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FilectimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FilemodifiedTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FilemtimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type FileConnection = {
  __typename: 'FileConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<FileEdge>;
  group: Array<FileGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type FileConnectiondistinctArgs = {
  field: FileFieldsEnum;
};


export type FileConnectiongroupArgs = {
  field: FileFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FileConnectionmaxArgs = {
  field: FileFieldsEnum;
};


export type FileConnectionminArgs = {
  field: FileFieldsEnum;
};


export type FileConnectionsumArgs = {
  field: FileFieldsEnum;
};

export type FileEdge = {
  __typename: 'FileEdge';
  next: Maybe<File>;
  node: File;
  previous: Maybe<File>;
};

export enum FileFieldsEnum {
  absolutePath = 'absolutePath',
  accessTime = 'accessTime',
  atime = 'atime',
  atimeMs = 'atimeMs',
  base = 'base',
  birthTime = 'birthTime',
  birthtime = 'birthtime',
  birthtimeMs = 'birthtimeMs',
  changeTime = 'changeTime',
  children = 'children',
  children___children = 'children___children',
  children___children___children = 'children___children___children',
  children___children___children___children = 'children___children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___id = 'children___children___id',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___contentFilePath = 'children___children___internal___contentFilePath',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___children___parent___children = 'children___children___parent___children',
  children___children___parent___id = 'children___children___parent___id',
  children___id = 'children___id',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___contentFilePath = 'children___internal___contentFilePath',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  children___parent___children = 'children___parent___children',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___id = 'children___parent___id',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___contentFilePath = 'children___parent___internal___contentFilePath',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___parent___id = 'children___parent___parent___id',
  ctime = 'ctime',
  ctimeMs = 'ctimeMs',
  dev = 'dev',
  dir = 'dir',
  ext = 'ext',
  extension = 'extension',
  gid = 'gid',
  id = 'id',
  ino = 'ino',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___contentFilePath = 'internal___contentFilePath',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  mode = 'mode',
  modifiedTime = 'modifiedTime',
  mtime = 'mtime',
  mtimeMs = 'mtimeMs',
  name = 'name',
  nlink = 'nlink',
  parent___children = 'parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___id = 'parent___children___id',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___contentFilePath = 'parent___children___internal___contentFilePath',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___id = 'parent___id',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___contentFilePath = 'parent___internal___contentFilePath',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___contentFilePath = 'parent___parent___internal___contentFilePath',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___parent___id = 'parent___parent___parent___id',
  prettySize = 'prettySize',
  rdev = 'rdev',
  relativeDirectory = 'relativeDirectory',
  relativePath = 'relativePath',
  root = 'root',
  size = 'size',
  sourceInstanceName = 'sourceInstanceName',
  uid = 'uid'
}

export type FileFilterInput = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};

export type FileGroupConnection = {
  __typename: 'FileGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<FileEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<FileGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type FileGroupConnectiondistinctArgs = {
  field: FileFieldsEnum;
};


export type FileGroupConnectiongroupArgs = {
  field: FileFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FileGroupConnectionmaxArgs = {
  field: FileFieldsEnum;
};


export type FileGroupConnectionminArgs = {
  field: FileFieldsEnum;
};


export type FileGroupConnectionsumArgs = {
  field: FileFieldsEnum;
};

export type FileSortInput = {
  fields?: InputMaybe<Array<InputMaybe<FileFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type FloatQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type GraphQLSource = Node & {
  __typename: 'GraphQLSource';
  children: Array<Node>;
  fieldName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internal: Internal;
  parent: Maybe<Node>;
  typeName: Maybe<Scalars['String']>;
};

export type GraphQLSourceConnection = {
  __typename: 'GraphQLSourceConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<GraphQLSourceEdge>;
  group: Array<GraphQLSourceGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<GraphQLSource>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type GraphQLSourceConnectiondistinctArgs = {
  field: GraphQLSourceFieldsEnum;
};


export type GraphQLSourceConnectiongroupArgs = {
  field: GraphQLSourceFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type GraphQLSourceConnectionmaxArgs = {
  field: GraphQLSourceFieldsEnum;
};


export type GraphQLSourceConnectionminArgs = {
  field: GraphQLSourceFieldsEnum;
};


export type GraphQLSourceConnectionsumArgs = {
  field: GraphQLSourceFieldsEnum;
};

export type GraphQLSourceEdge = {
  __typename: 'GraphQLSourceEdge';
  next: Maybe<GraphQLSource>;
  node: GraphQLSource;
  previous: Maybe<GraphQLSource>;
};

export enum GraphQLSourceFieldsEnum {
  children = 'children',
  children___children = 'children___children',
  children___children___children = 'children___children___children',
  children___children___children___children = 'children___children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___id = 'children___children___id',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___contentFilePath = 'children___children___internal___contentFilePath',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___children___parent___children = 'children___children___parent___children',
  children___children___parent___id = 'children___children___parent___id',
  children___id = 'children___id',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___contentFilePath = 'children___internal___contentFilePath',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  children___parent___children = 'children___parent___children',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___id = 'children___parent___id',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___contentFilePath = 'children___parent___internal___contentFilePath',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___parent___id = 'children___parent___parent___id',
  fieldName = 'fieldName',
  id = 'id',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___contentFilePath = 'internal___contentFilePath',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  parent___children = 'parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___id = 'parent___children___id',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___contentFilePath = 'parent___children___internal___contentFilePath',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___id = 'parent___id',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___contentFilePath = 'parent___internal___contentFilePath',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___contentFilePath = 'parent___parent___internal___contentFilePath',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___parent___id = 'parent___parent___parent___id',
  typeName = 'typeName'
}

export type GraphQLSourceFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  fieldName?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  typeName?: InputMaybe<StringQueryOperatorInput>;
};

export type GraphQLSourceGroupConnection = {
  __typename: 'GraphQLSourceGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<GraphQLSourceEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<GraphQLSourceGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<GraphQLSource>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type GraphQLSourceGroupConnectiondistinctArgs = {
  field: GraphQLSourceFieldsEnum;
};


export type GraphQLSourceGroupConnectiongroupArgs = {
  field: GraphQLSourceFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type GraphQLSourceGroupConnectionmaxArgs = {
  field: GraphQLSourceFieldsEnum;
};


export type GraphQLSourceGroupConnectionminArgs = {
  field: GraphQLSourceFieldsEnum;
};


export type GraphQLSourceGroupConnectionsumArgs = {
  field: GraphQLSourceFieldsEnum;
};

export type GraphQLSourceSortInput = {
  fields?: InputMaybe<Array<InputMaybe<GraphQLSourceFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type IntQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type Internal = {
  __typename: 'Internal';
  content: Maybe<Scalars['String']>;
  contentDigest: Scalars['String'];
  contentFilePath: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  fieldOwners: Maybe<Array<Maybe<Scalars['String']>>>;
  ignoreType: Maybe<Scalars['Boolean']>;
  mediaType: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  type: Scalars['String'];
};

export type InternalFilterInput = {
  content?: InputMaybe<StringQueryOperatorInput>;
  contentDigest?: InputMaybe<StringQueryOperatorInput>;
  contentFilePath?: InputMaybe<StringQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  fieldOwners?: InputMaybe<StringQueryOperatorInput>;
  ignoreType?: InputMaybe<BooleanQueryOperatorInput>;
  mediaType?: InputMaybe<StringQueryOperatorInput>;
  owner?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
};

export type JSONQueryOperatorInput = {
  eq?: InputMaybe<Scalars['JSON']>;
  glob?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  regex?: InputMaybe<Scalars['JSON']>;
};

export type Node = {
  children: Array<Node>;
  id: Scalars['ID'];
  internal: Internal;
  parent: Maybe<Node>;
};

export type NodeFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};

export type NodeFilterListInput = {
  elemMatch?: InputMaybe<NodeFilterInput>;
};

export type PageInfo = {
  __typename: 'PageInfo';
  currentPage: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  itemCount: Scalars['Int'];
  pageCount: Scalars['Int'];
  perPage: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

export type Query = {
  __typename: 'Query';
  allDirectory: DirectoryConnection;
  allFile: FileConnection;
  allGraphQlSource: GraphQLSourceConnection;
  allSite: SiteConnection;
  allSiteBuildMetadata: SiteBuildMetadataConnection;
  allSiteFunction: SiteFunctionConnection;
  allSitePage: SitePageConnection;
  allSitePlugin: SitePluginConnection;
  directory: Maybe<Directory>;
  file: Maybe<File>;
  graphQlSource: Maybe<GraphQLSource>;
  site: Maybe<Site>;
  siteBuildMetadata: Maybe<SiteBuildMetadata>;
  siteFunction: Maybe<SiteFunction>;
  sitePage: Maybe<SitePage>;
  sitePlugin: Maybe<SitePlugin>;
  ssr: CMS_SSR;
};


export type QueryallDirectoryArgs = {
  filter?: InputMaybe<DirectoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DirectorySortInput>;
};


export type QueryallFileArgs = {
  filter?: InputMaybe<FileFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<FileSortInput>;
};


export type QueryallGraphQlSourceArgs = {
  filter?: InputMaybe<GraphQLSourceFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<GraphQLSourceSortInput>;
};


export type QueryallSiteArgs = {
  filter?: InputMaybe<SiteFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SiteSortInput>;
};


export type QueryallSiteBuildMetadataArgs = {
  filter?: InputMaybe<SiteBuildMetadataFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SiteBuildMetadataSortInput>;
};


export type QueryallSiteFunctionArgs = {
  filter?: InputMaybe<SiteFunctionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SiteFunctionSortInput>;
};


export type QueryallSitePageArgs = {
  filter?: InputMaybe<SitePageFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SitePageSortInput>;
};


export type QueryallSitePluginArgs = {
  filter?: InputMaybe<SitePluginFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SitePluginSortInput>;
};


export type QuerydirectoryArgs = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};


export type QueryfileArgs = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};


export type QuerygraphQlSourceArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  fieldName?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  typeName?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerysiteArgs = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  graphqlTypegen?: InputMaybe<BooleanQueryOperatorInput>;
  host?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  jsxRuntime?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pathPrefix?: InputMaybe<StringQueryOperatorInput>;
  polyfill?: InputMaybe<BooleanQueryOperatorInput>;
  port?: InputMaybe<IntQueryOperatorInput>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFilterInput>;
  trailingSlash?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerysiteBuildMetadataArgs = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};


export type QuerysiteFunctionArgs = {
  absoluteCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  functionRoute?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: InputMaybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginName?: InputMaybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerysitePageArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  component?: InputMaybe<StringQueryOperatorInput>;
  componentChunkName?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalComponentName?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  pageContext?: InputMaybe<JSONQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  pluginCreator?: InputMaybe<SitePluginFilterInput>;
};


export type QuerysitePluginArgs = {
  browserAPIs?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nodeAPIs?: InputMaybe<StringQueryOperatorInput>;
  packageJson?: InputMaybe<JSONQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginFilepath?: InputMaybe<StringQueryOperatorInput>;
  pluginOptions?: InputMaybe<JSONQueryOperatorInput>;
  resolve?: InputMaybe<StringQueryOperatorInput>;
  ssrAPIs?: InputMaybe<StringQueryOperatorInput>;
  version?: InputMaybe<StringQueryOperatorInput>;
};

export type Site = Node & {
  __typename: 'Site';
  buildTime: Maybe<Scalars['Date']>;
  children: Array<Node>;
  graphqlTypegen: Maybe<Scalars['Boolean']>;
  host: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internal: Internal;
  jsxRuntime: Maybe<Scalars['String']>;
  parent: Maybe<Node>;
  pathPrefix: Maybe<Scalars['String']>;
  polyfill: Maybe<Scalars['Boolean']>;
  port: Maybe<Scalars['Int']>;
  siteMetadata: Maybe<SiteSiteMetadata>;
  trailingSlash: Maybe<Scalars['String']>;
};


export type SitebuildTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SiteBuildMetadata = Node & {
  __typename: 'SiteBuildMetadata';
  buildTime: Maybe<Scalars['Date']>;
  children: Array<Node>;
  id: Scalars['ID'];
  internal: Internal;
  parent: Maybe<Node>;
};


export type SiteBuildMetadatabuildTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SiteBuildMetadataConnection = {
  __typename: 'SiteBuildMetadataConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteBuildMetadataEdge>;
  group: Array<SiteBuildMetadataGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteBuildMetadataConnectiondistinctArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectiongroupArgs = {
  field: SiteBuildMetadataFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteBuildMetadataConnectionmaxArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectionminArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectionsumArgs = {
  field: SiteBuildMetadataFieldsEnum;
};

export type SiteBuildMetadataEdge = {
  __typename: 'SiteBuildMetadataEdge';
  next: Maybe<SiteBuildMetadata>;
  node: SiteBuildMetadata;
  previous: Maybe<SiteBuildMetadata>;
};

export enum SiteBuildMetadataFieldsEnum {
  buildTime = 'buildTime',
  children = 'children',
  children___children = 'children___children',
  children___children___children = 'children___children___children',
  children___children___children___children = 'children___children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___id = 'children___children___id',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___contentFilePath = 'children___children___internal___contentFilePath',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___children___parent___children = 'children___children___parent___children',
  children___children___parent___id = 'children___children___parent___id',
  children___id = 'children___id',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___contentFilePath = 'children___internal___contentFilePath',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  children___parent___children = 'children___parent___children',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___id = 'children___parent___id',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___contentFilePath = 'children___parent___internal___contentFilePath',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___parent___id = 'children___parent___parent___id',
  id = 'id',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___contentFilePath = 'internal___contentFilePath',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  parent___children = 'parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___id = 'parent___children___id',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___contentFilePath = 'parent___children___internal___contentFilePath',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___id = 'parent___id',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___contentFilePath = 'parent___internal___contentFilePath',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___contentFilePath = 'parent___parent___internal___contentFilePath',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___parent___id = 'parent___parent___parent___id'
}

export type SiteBuildMetadataFilterInput = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};

export type SiteBuildMetadataGroupConnection = {
  __typename: 'SiteBuildMetadataGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteBuildMetadataEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<SiteBuildMetadataGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteBuildMetadataGroupConnectiondistinctArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataGroupConnectiongroupArgs = {
  field: SiteBuildMetadataFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteBuildMetadataGroupConnectionmaxArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataGroupConnectionminArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataGroupConnectionsumArgs = {
  field: SiteBuildMetadataFieldsEnum;
};

export type SiteBuildMetadataSortInput = {
  fields?: InputMaybe<Array<InputMaybe<SiteBuildMetadataFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type SiteConnection = {
  __typename: 'SiteConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteEdge>;
  group: Array<SiteGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteConnectiondistinctArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectiongroupArgs = {
  field: SiteFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteConnectionmaxArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectionminArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectionsumArgs = {
  field: SiteFieldsEnum;
};

export type SiteEdge = {
  __typename: 'SiteEdge';
  next: Maybe<Site>;
  node: Site;
  previous: Maybe<Site>;
};

export enum SiteFieldsEnum {
  buildTime = 'buildTime',
  children = 'children',
  children___children = 'children___children',
  children___children___children = 'children___children___children',
  children___children___children___children = 'children___children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___id = 'children___children___id',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___contentFilePath = 'children___children___internal___contentFilePath',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___children___parent___children = 'children___children___parent___children',
  children___children___parent___id = 'children___children___parent___id',
  children___id = 'children___id',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___contentFilePath = 'children___internal___contentFilePath',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  children___parent___children = 'children___parent___children',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___id = 'children___parent___id',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___contentFilePath = 'children___parent___internal___contentFilePath',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___parent___id = 'children___parent___parent___id',
  graphqlTypegen = 'graphqlTypegen',
  host = 'host',
  id = 'id',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___contentFilePath = 'internal___contentFilePath',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  jsxRuntime = 'jsxRuntime',
  parent___children = 'parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___id = 'parent___children___id',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___contentFilePath = 'parent___children___internal___contentFilePath',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___id = 'parent___id',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___contentFilePath = 'parent___internal___contentFilePath',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___contentFilePath = 'parent___parent___internal___contentFilePath',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___parent___id = 'parent___parent___parent___id',
  pathPrefix = 'pathPrefix',
  polyfill = 'polyfill',
  port = 'port',
  siteMetadata___description = 'siteMetadata___description',
  siteMetadata___siteUrl = 'siteMetadata___siteUrl',
  siteMetadata___title = 'siteMetadata___title',
  trailingSlash = 'trailingSlash'
}

export type SiteFilterInput = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  graphqlTypegen?: InputMaybe<BooleanQueryOperatorInput>;
  host?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  jsxRuntime?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pathPrefix?: InputMaybe<StringQueryOperatorInput>;
  polyfill?: InputMaybe<BooleanQueryOperatorInput>;
  port?: InputMaybe<IntQueryOperatorInput>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFilterInput>;
  trailingSlash?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteFunction = Node & {
  __typename: 'SiteFunction';
  absoluteCompiledFilePath: Scalars['String'];
  children: Array<Node>;
  functionRoute: Scalars['String'];
  id: Scalars['ID'];
  internal: Internal;
  matchPath: Maybe<Scalars['String']>;
  originalAbsoluteFilePath: Scalars['String'];
  originalRelativeFilePath: Scalars['String'];
  parent: Maybe<Node>;
  pluginName: Scalars['String'];
  relativeCompiledFilePath: Scalars['String'];
};

export type SiteFunctionConnection = {
  __typename: 'SiteFunctionConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteFunctionEdge>;
  group: Array<SiteFunctionGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteFunctionConnectiondistinctArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionConnectiongroupArgs = {
  field: SiteFunctionFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteFunctionConnectionmaxArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionConnectionminArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionConnectionsumArgs = {
  field: SiteFunctionFieldsEnum;
};

export type SiteFunctionEdge = {
  __typename: 'SiteFunctionEdge';
  next: Maybe<SiteFunction>;
  node: SiteFunction;
  previous: Maybe<SiteFunction>;
};

export enum SiteFunctionFieldsEnum {
  absoluteCompiledFilePath = 'absoluteCompiledFilePath',
  children = 'children',
  children___children = 'children___children',
  children___children___children = 'children___children___children',
  children___children___children___children = 'children___children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___id = 'children___children___id',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___contentFilePath = 'children___children___internal___contentFilePath',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___children___parent___children = 'children___children___parent___children',
  children___children___parent___id = 'children___children___parent___id',
  children___id = 'children___id',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___contentFilePath = 'children___internal___contentFilePath',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  children___parent___children = 'children___parent___children',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___id = 'children___parent___id',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___contentFilePath = 'children___parent___internal___contentFilePath',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___parent___id = 'children___parent___parent___id',
  functionRoute = 'functionRoute',
  id = 'id',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___contentFilePath = 'internal___contentFilePath',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  matchPath = 'matchPath',
  originalAbsoluteFilePath = 'originalAbsoluteFilePath',
  originalRelativeFilePath = 'originalRelativeFilePath',
  parent___children = 'parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___id = 'parent___children___id',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___contentFilePath = 'parent___children___internal___contentFilePath',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___id = 'parent___id',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___contentFilePath = 'parent___internal___contentFilePath',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___contentFilePath = 'parent___parent___internal___contentFilePath',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___parent___id = 'parent___parent___parent___id',
  pluginName = 'pluginName',
  relativeCompiledFilePath = 'relativeCompiledFilePath'
}

export type SiteFunctionFilterInput = {
  absoluteCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  functionRoute?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: InputMaybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginName?: InputMaybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteFunctionGroupConnection = {
  __typename: 'SiteFunctionGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteFunctionEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<SiteFunctionGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteFunctionGroupConnectiondistinctArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionGroupConnectiongroupArgs = {
  field: SiteFunctionFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteFunctionGroupConnectionmaxArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionGroupConnectionminArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionGroupConnectionsumArgs = {
  field: SiteFunctionFieldsEnum;
};

export type SiteFunctionSortInput = {
  fields?: InputMaybe<Array<InputMaybe<SiteFunctionFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type SiteGroupConnection = {
  __typename: 'SiteGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<SiteGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteGroupConnectiondistinctArgs = {
  field: SiteFieldsEnum;
};


export type SiteGroupConnectiongroupArgs = {
  field: SiteFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteGroupConnectionmaxArgs = {
  field: SiteFieldsEnum;
};


export type SiteGroupConnectionminArgs = {
  field: SiteFieldsEnum;
};


export type SiteGroupConnectionsumArgs = {
  field: SiteFieldsEnum;
};

export type SitePage = Node & {
  __typename: 'SitePage';
  children: Array<Node>;
  component: Scalars['String'];
  componentChunkName: Scalars['String'];
  id: Scalars['ID'];
  internal: Internal;
  internalComponentName: Scalars['String'];
  matchPath: Maybe<Scalars['String']>;
  pageContext: Maybe<Scalars['JSON']>;
  parent: Maybe<Node>;
  path: Scalars['String'];
  pluginCreator: Maybe<SitePlugin>;
};

export type SitePageConnection = {
  __typename: 'SitePageConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SitePageEdge>;
  group: Array<SitePageGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePageConnectiondistinctArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectiongroupArgs = {
  field: SitePageFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePageConnectionmaxArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectionminArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectionsumArgs = {
  field: SitePageFieldsEnum;
};

export type SitePageEdge = {
  __typename: 'SitePageEdge';
  next: Maybe<SitePage>;
  node: SitePage;
  previous: Maybe<SitePage>;
};

export enum SitePageFieldsEnum {
  children = 'children',
  children___children = 'children___children',
  children___children___children = 'children___children___children',
  children___children___children___children = 'children___children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___id = 'children___children___id',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___contentFilePath = 'children___children___internal___contentFilePath',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___children___parent___children = 'children___children___parent___children',
  children___children___parent___id = 'children___children___parent___id',
  children___id = 'children___id',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___contentFilePath = 'children___internal___contentFilePath',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  children___parent___children = 'children___parent___children',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___id = 'children___parent___id',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___contentFilePath = 'children___parent___internal___contentFilePath',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___parent___id = 'children___parent___parent___id',
  component = 'component',
  componentChunkName = 'componentChunkName',
  id = 'id',
  internalComponentName = 'internalComponentName',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___contentFilePath = 'internal___contentFilePath',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  matchPath = 'matchPath',
  pageContext = 'pageContext',
  parent___children = 'parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___id = 'parent___children___id',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___contentFilePath = 'parent___children___internal___contentFilePath',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___id = 'parent___id',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___contentFilePath = 'parent___internal___contentFilePath',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___contentFilePath = 'parent___parent___internal___contentFilePath',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___parent___id = 'parent___parent___parent___id',
  path = 'path',
  pluginCreator___browserAPIs = 'pluginCreator___browserAPIs',
  pluginCreator___children = 'pluginCreator___children',
  pluginCreator___children___children = 'pluginCreator___children___children',
  pluginCreator___children___children___children = 'pluginCreator___children___children___children',
  pluginCreator___children___children___id = 'pluginCreator___children___children___id',
  pluginCreator___children___id = 'pluginCreator___children___id',
  pluginCreator___children___internal___content = 'pluginCreator___children___internal___content',
  pluginCreator___children___internal___contentDigest = 'pluginCreator___children___internal___contentDigest',
  pluginCreator___children___internal___contentFilePath = 'pluginCreator___children___internal___contentFilePath',
  pluginCreator___children___internal___description = 'pluginCreator___children___internal___description',
  pluginCreator___children___internal___fieldOwners = 'pluginCreator___children___internal___fieldOwners',
  pluginCreator___children___internal___ignoreType = 'pluginCreator___children___internal___ignoreType',
  pluginCreator___children___internal___mediaType = 'pluginCreator___children___internal___mediaType',
  pluginCreator___children___internal___owner = 'pluginCreator___children___internal___owner',
  pluginCreator___children___internal___type = 'pluginCreator___children___internal___type',
  pluginCreator___children___parent___children = 'pluginCreator___children___parent___children',
  pluginCreator___children___parent___id = 'pluginCreator___children___parent___id',
  pluginCreator___id = 'pluginCreator___id',
  pluginCreator___internal___content = 'pluginCreator___internal___content',
  pluginCreator___internal___contentDigest = 'pluginCreator___internal___contentDigest',
  pluginCreator___internal___contentFilePath = 'pluginCreator___internal___contentFilePath',
  pluginCreator___internal___description = 'pluginCreator___internal___description',
  pluginCreator___internal___fieldOwners = 'pluginCreator___internal___fieldOwners',
  pluginCreator___internal___ignoreType = 'pluginCreator___internal___ignoreType',
  pluginCreator___internal___mediaType = 'pluginCreator___internal___mediaType',
  pluginCreator___internal___owner = 'pluginCreator___internal___owner',
  pluginCreator___internal___type = 'pluginCreator___internal___type',
  pluginCreator___name = 'pluginCreator___name',
  pluginCreator___nodeAPIs = 'pluginCreator___nodeAPIs',
  pluginCreator___packageJson = 'pluginCreator___packageJson',
  pluginCreator___parent___children = 'pluginCreator___parent___children',
  pluginCreator___parent___children___children = 'pluginCreator___parent___children___children',
  pluginCreator___parent___children___id = 'pluginCreator___parent___children___id',
  pluginCreator___parent___id = 'pluginCreator___parent___id',
  pluginCreator___parent___internal___content = 'pluginCreator___parent___internal___content',
  pluginCreator___parent___internal___contentDigest = 'pluginCreator___parent___internal___contentDigest',
  pluginCreator___parent___internal___contentFilePath = 'pluginCreator___parent___internal___contentFilePath',
  pluginCreator___parent___internal___description = 'pluginCreator___parent___internal___description',
  pluginCreator___parent___internal___fieldOwners = 'pluginCreator___parent___internal___fieldOwners',
  pluginCreator___parent___internal___ignoreType = 'pluginCreator___parent___internal___ignoreType',
  pluginCreator___parent___internal___mediaType = 'pluginCreator___parent___internal___mediaType',
  pluginCreator___parent___internal___owner = 'pluginCreator___parent___internal___owner',
  pluginCreator___parent___internal___type = 'pluginCreator___parent___internal___type',
  pluginCreator___parent___parent___children = 'pluginCreator___parent___parent___children',
  pluginCreator___parent___parent___id = 'pluginCreator___parent___parent___id',
  pluginCreator___pluginFilepath = 'pluginCreator___pluginFilepath',
  pluginCreator___pluginOptions = 'pluginCreator___pluginOptions',
  pluginCreator___resolve = 'pluginCreator___resolve',
  pluginCreator___ssrAPIs = 'pluginCreator___ssrAPIs',
  pluginCreator___version = 'pluginCreator___version'
}

export type SitePageFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  component?: InputMaybe<StringQueryOperatorInput>;
  componentChunkName?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalComponentName?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  pageContext?: InputMaybe<JSONQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  pluginCreator?: InputMaybe<SitePluginFilterInput>;
};

export type SitePageGroupConnection = {
  __typename: 'SitePageGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SitePageEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<SitePageGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePageGroupConnectiondistinctArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageGroupConnectiongroupArgs = {
  field: SitePageFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePageGroupConnectionmaxArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageGroupConnectionminArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageGroupConnectionsumArgs = {
  field: SitePageFieldsEnum;
};

export type SitePageSortInput = {
  fields?: InputMaybe<Array<InputMaybe<SitePageFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type SitePlugin = Node & {
  __typename: 'SitePlugin';
  browserAPIs: Maybe<Array<Maybe<Scalars['String']>>>;
  children: Array<Node>;
  id: Scalars['ID'];
  internal: Internal;
  name: Maybe<Scalars['String']>;
  nodeAPIs: Maybe<Array<Maybe<Scalars['String']>>>;
  packageJson: Maybe<Scalars['JSON']>;
  parent: Maybe<Node>;
  pluginFilepath: Maybe<Scalars['String']>;
  pluginOptions: Maybe<Scalars['JSON']>;
  resolve: Maybe<Scalars['String']>;
  ssrAPIs: Maybe<Array<Maybe<Scalars['String']>>>;
  version: Maybe<Scalars['String']>;
};

export type SitePluginConnection = {
  __typename: 'SitePluginConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SitePluginEdge>;
  group: Array<SitePluginGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePluginConnectiondistinctArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectiongroupArgs = {
  field: SitePluginFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePluginConnectionmaxArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectionminArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectionsumArgs = {
  field: SitePluginFieldsEnum;
};

export type SitePluginEdge = {
  __typename: 'SitePluginEdge';
  next: Maybe<SitePlugin>;
  node: SitePlugin;
  previous: Maybe<SitePlugin>;
};

export enum SitePluginFieldsEnum {
  browserAPIs = 'browserAPIs',
  children = 'children',
  children___children = 'children___children',
  children___children___children = 'children___children___children',
  children___children___children___children = 'children___children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___id = 'children___children___id',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___contentFilePath = 'children___children___internal___contentFilePath',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___children___parent___children = 'children___children___parent___children',
  children___children___parent___id = 'children___children___parent___id',
  children___id = 'children___id',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___contentFilePath = 'children___internal___contentFilePath',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  children___parent___children = 'children___parent___children',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___id = 'children___parent___id',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___contentFilePath = 'children___parent___internal___contentFilePath',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___parent___id = 'children___parent___parent___id',
  id = 'id',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___contentFilePath = 'internal___contentFilePath',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type',
  name = 'name',
  nodeAPIs = 'nodeAPIs',
  packageJson = 'packageJson',
  parent___children = 'parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___id = 'parent___children___id',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___contentFilePath = 'parent___children___internal___contentFilePath',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___id = 'parent___id',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___contentFilePath = 'parent___internal___contentFilePath',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___contentFilePath = 'parent___parent___internal___contentFilePath',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___parent___id = 'parent___parent___parent___id',
  pluginFilepath = 'pluginFilepath',
  pluginOptions = 'pluginOptions',
  resolve = 'resolve',
  ssrAPIs = 'ssrAPIs',
  version = 'version'
}

export type SitePluginFilterInput = {
  browserAPIs?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nodeAPIs?: InputMaybe<StringQueryOperatorInput>;
  packageJson?: InputMaybe<JSONQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginFilepath?: InputMaybe<StringQueryOperatorInput>;
  pluginOptions?: InputMaybe<JSONQueryOperatorInput>;
  resolve?: InputMaybe<StringQueryOperatorInput>;
  ssrAPIs?: InputMaybe<StringQueryOperatorInput>;
  version?: InputMaybe<StringQueryOperatorInput>;
};

export type SitePluginGroupConnection = {
  __typename: 'SitePluginGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SitePluginEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<SitePluginGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePluginGroupConnectiondistinctArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginGroupConnectiongroupArgs = {
  field: SitePluginFieldsEnum;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePluginGroupConnectionmaxArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginGroupConnectionminArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginGroupConnectionsumArgs = {
  field: SitePluginFieldsEnum;
};

export type SitePluginSortInput = {
  fields?: InputMaybe<Array<InputMaybe<SitePluginFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type SiteSiteMetadata = {
  __typename: 'SiteSiteMetadata';
  description: Maybe<Scalars['String']>;
  siteUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type SiteSiteMetadataFilterInput = {
  description?: InputMaybe<StringQueryOperatorInput>;
  siteUrl?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteSortInput = {
  fields?: InputMaybe<Array<InputMaybe<SiteFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export enum SortOrderEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StringQueryOperatorInput = {
  eq?: InputMaybe<Scalars['String']>;
  glob?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['String']>;
};

export type ActiveLicenceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveLicenceTypesQuery = { ssr: { __typename: 'CMS_SSR', activeLicenceTypes: Array<{ __typename: 'CMS_SSR_LicenceTypeInterface', id: string, name: string, isAvailableViaCart: boolean, tieredLicensing: Array<{ __typename: 'CMS_SSR_TieredLicensingInterface', id: string, title: string, isActive: boolean, unitStr: string, unitStrPlural: string, tiers: Array<{ __typename: 'CMS_SSR_TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, licenceType: { __typename: 'CMS_SSR_LicenceTypeInterface', id: string }, tieredLicence: { __typename: 'CMS_SSR_TieredLicensingInterface', id: string } }> }> }> } };

export type AllFontsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFontsQuery = { ssr: { __typename: 'CMS_SSR', fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, name: string, slug: string, isCollection: boolean, isNew: boolean, informationIntro: string | null, showInCustomFontMenu: boolean, svgNavigation: string | null, typographicRanking: number | null, designInformationPage: { __typename: 'CMS_SSR_BlogPage', slug: string } | null, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }>, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, name: string, slug: string, isPreRelease: boolean, fontStyleCount: number, release: any | null, fontSizeMultiplier: number, typographicRanking: number | null, hasVariableFonts: boolean, vfRomanFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, woff2FileSize: number | null } | null, vfItalicFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, woff2FileSize: number | null } | null, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleInterface', id: string, name: string, weight: number, typographicRanking: number | null, ttfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null } | null }>, subfamilies: Array<{ __typename: 'CMS_SSR_FontSubfamilyInterface', name: string }>, mainFontStyle: { __typename: 'CMS_SSR_FontStyleInterface', id: string, name: string, weight: number, typographicRanking: number | null, ttfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null } }> }> } };

export type AwardsQueryVariables = Exact<{ [key: string]: never; }>;


export type AwardsQuery = { ssr: { __typename: 'CMS_SSR', awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, name: string, year: number, receivedFor: string | null, sortOrder: number, essentialContribution: boolean, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', isPreRelease: boolean, name: string, slug: string, typographicRanking: number | null }>, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', isCollection: boolean, name: string, slug: string, typographicRanking: number | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', isPreRelease: boolean, name: string, slug: string, typographicRanking: number | null }> }>, customFonts: Array<{ __typename: 'CMS_SSR_CustomFontInterface', isPreRelease: boolean, name: string, slug: string | null }> }> } };

export type ConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigQuery = { ssr: { __typename: 'CMS_SSR', config: { __typename: 'CMS_SSR_ConfigInterface', userTestingHostname: string | null, userTestingCheckoutAllowed: boolean, isProductionSite: boolean, unitPriceFontStyle: number, businessName: string, businessUrl: string, emailSupport: string, baseCurrency: CMS_SSR_CurrencyChoices, buildDateTime: any, customOpentypeHtmlTagNames: Array<string>, awardPageIntro: string, crossLicenceDiscountPercentage: number, licenceTypeShortNames: Array<CMS_SSR_LicenceTypeShortName>, bigSpecimenRefFontSizePx: number, userTestingFontFamilyGroupWhitelist: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, slug: string }>, eulas: Array<{ __typename: 'CMS_SSR_EulaInterface', licenceTypeId: CMS_SSR_LicenceTypeId, title: string, shortName: string }>, countries: Array<{ __typename: 'CMS_SSR_CountryInterface', name: string, code: CMS_SSR_CountryChoices, taxId: string | null }>, styleDiscountPercentages: Array<{ __typename: 'CMS_SSR_StyleDiscountPercentage', quantity: number, discount: number }>, packageDiscountPercentages: Array<{ __typename: 'CMS_SSR_PackageDiscountPercentage', fontProductType: CMS_SSR_FontProductTypeChoice, discount: number }>, openTypeFeatureMetaData: Array<{ __typename: 'CMS_SSR_OpenTypeFeatureMetaDataInterface', tag: string, defaultLabel: string, defaultExample: string | null, defaultAllGlyphs: string | null, defaultDescription: string | null }> } } };

export type CustomFontsStubsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomFontsStubsQuery = { ssr: { __typename: 'CMS_SSR', customFonts: Array<{ __typename: 'CMS_SSR_CustomFontInterface', creditClient: Array<string>, id: string, isPreRelease: boolean, name: string, slug: string | null, svgNavigation: string | null, backgroundColor: string, foregroundColor: string, highlightColor: string, styles: Array<{ __typename: 'CMS_SSR_CustomFontStyleInterface', name: string, family: { __typename: 'CMS_SSR_CustomFontFamilyInterface', name: string, sortOrder: number } | null }> }> } };

export type InUsePostStubsQueryVariables = Exact<{ [key: string]: never; }>;


export type InUsePostStubsQuery = { ssr: { __typename: 'CMS_SSR', inUsePosts: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPage', id: string | null, title: string, seoTitle: string, slug: string, postDate: any, noindex: boolean, mediaCount: number, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag', id: string | null, name: string | null, slug: string | null }> | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', name: string, slug: string, typographicRanking: number | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string } }> | null }> | null } };

export type TestFontsFilesizeQueryVariables = Exact<{ [key: string]: never; }>;


export type TestFontsFilesizeQuery = { ssr: { __typename: 'CMS_SSR', testFonts: { __typename: 'CMS_SSR_TestFontsInterface', allFontsArchiveFilesize: number | null } } };

export type FeaturedInUsePostFragment = { __typename: 'CMS_SSR_FontsInUseDetailPage', id: string | null, title: string, seoTitle: string, slug: string, postDate: any, mediaCount: number, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag', id: string | null, name: string | null, slug: string | null }> | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', slug: string, name: string, typographicRanking: number | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string } }> | null };

export type ColorSchemeFragment = { __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null };

export type FontMetricsFragment = { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number };

export type CssRenderInfoFragment = { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null };

export type FontVariationAxesFragment = { __typename: 'CMS_SSR_FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number };

export type BlogPostStubFragment = { __typename: 'CMS_SSR_BlogPage', noindex: boolean, blurb: string | null, id: string | null, title: string, seoTitle: string, slug: string, postDate: any, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_BlogTag', id: string | null, name: string | null, slug: string | null }>, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string }> | null };

export type FontStyleFragment = { __typename: 'CMS_SSR_FontStyleInterface', id: string, name: string, weight: number, pointSize: number | null, pixelSize: number | null, unitPrice: number, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontSizeMultiplier: number, typographicRanking: number | null, openTypeFeatures: Array<{ __typename: 'CMS_SSR_FontOpenTypeFeatureInterface', tag: string, label: string | null }>, ttfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, woff2FileSize: number | null } | null, otfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woffFile: string, metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, fontSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } };

export type CampaignImageFragment = { __typename: 'CMS_SSR_CampaignImageInterface', id: string, sortOrder: number, imageLandscape: string, imageLandscapeWidth: number, imageLandscapeHeight: number, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, imagePortrait: string | null, imagePortraitWidth: number | null, imagePortraitHeight: number | null, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorLoaderForeground: string | null, colorLoaderBackground: string | null, colorBackground: string | null };

export type VimeoVideoFragment = { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> };

export type CampaignVideoFragment = { __typename: 'CMS_SSR_CampaignVideoInterface', id: string, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorLoaderForeground: string | null, colorLoaderBackground: string | null, videoLandscape: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> }, videoPortrait: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> } | null };

export type AwardFragment = { __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number };

export type EulasQueryVariables = Exact<{ [key: string]: never; }>;


export type EulasQuery = { ssr: { __typename: 'CMS_SSR', config: { __typename: 'CMS_SSR_ConfigInterface', eulas: Array<{ __typename: 'CMS_SSR_EulaInterface', licenceTypeId: CMS_SSR_LicenceTypeId, title: string, shortName: string, date: any, introHtml: Array<string>, sections: Array<{ __typename: 'CMS_SSR_EulaSectionInterface', title: string, id: string, num: number, subSections: Array<{ __typename: 'CMS_SSR_EulaSubSectionInterface', title: string | null, num: number, contentHtml: string }> }> }> } } };

export type CampaignFragment = { __typename: 'CMS_SSR_CampaignInterface', type: CMS_SSR_CampaignsCampaignTypeChoices, displayMode: CMS_SSR_CampaignsCampaignDisplayModeChoices, transitionDuration: number, transitionInterval: number, svgHeadingOverlay: boolean, images: Array<{ __typename: 'CMS_SSR_CampaignImageInterface', id: string, sortOrder: number, imageLandscape: string, imageLandscapeWidth: number, imageLandscapeHeight: number, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, imagePortrait: string | null, imagePortraitWidth: number | null, imagePortraitHeight: number | null, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorLoaderForeground: string | null, colorLoaderBackground: string | null, colorBackground: string | null }>, videos: Array<{ __typename: 'CMS_SSR_CampaignVideoInterface', id: string, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorLoaderForeground: string | null, colorLoaderBackground: string | null, videoLandscape: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> }, videoPortrait: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> } | null }> };

export type HomePageQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageQuery = { ssr: { __typename: 'CMS_SSR', homepage: { __typename: 'CMS_SSR_HomePage', slug: string, title: string, featuredFonts: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, name: string, slug: string, isCollection: boolean, isNew: boolean, svgNavigation: string | null, typographicRanking: number | null, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }>, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, name: string, slug: string, isPreRelease: boolean, fontStyleCount: number, typographicRanking: number | null }> }> | null, campaigns: Array<{ __typename: 'CMS_SSR_HomePageCampaign', fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, slug: string, name: string, isCollection: boolean, isNew: boolean, svgNavigation: string | null, typographicRanking: number | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, slug: string, name: string, isPreRelease: boolean }>, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }> }, campaign: { __typename: 'CMS_SSR_CampaignInterface', type: CMS_SSR_CampaignsCampaignTypeChoices, displayMode: CMS_SSR_CampaignsCampaignDisplayModeChoices, transitionDuration: number, transitionInterval: number, svgHeadingOverlay: boolean, images: Array<{ __typename: 'CMS_SSR_CampaignImageInterface', id: string, sortOrder: number, imageLandscape: string, imageLandscapeWidth: number, imageLandscapeHeight: number, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, imagePortrait: string | null, imagePortraitWidth: number | null, imagePortraitHeight: number | null, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorLoaderForeground: string | null, colorLoaderBackground: string | null, colorBackground: string | null }>, videos: Array<{ __typename: 'CMS_SSR_CampaignVideoInterface', id: string, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorLoaderForeground: string | null, colorLoaderBackground: string | null, videoLandscape: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> }, videoPortrait: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> } | null }> } }> | null, featuredBlogPosts: Array<{ __typename: 'CMS_SSR_BlogPage', noindex: boolean, blurb: string | null, id: string | null, title: string, seoTitle: string, slug: string, postDate: any, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_BlogTag', id: string | null, name: string | null, slug: string | null }>, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string }> | null } | null> | null, featuredInUsePosts: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPage', id: string | null, title: string, seoTitle: string, slug: string, postDate: any, mediaCount: number, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag', id: string | null, name: string | null, slug: string | null }> | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', slug: string, name: string, typographicRanking: number | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string } }> | null } | null> | null } } };

export type FontFamiliesQueryVariables = Exact<{ [key: string]: never; }>;


export type FontFamiliesQuery = { ssr: { __typename: 'CMS_SSR', fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, slug: string, name: string, fontSizeMultiplier: number, fontStyleCount: number, creditDesign: Array<string>, creditEngineering: Array<string>, creditCollaborators: Array<string>, release: any | null, classification: Array<string>, typographicRanking: number | null, supportedLanguages: Array<string>, svgHeading: string | null, seoTitle: string, seoDescription: string, seoImage: string, isPreRelease: boolean, hasVariableFonts: boolean, versionNumber: number | null, openTypeFeatures: Array<{ __typename: 'CMS_SSR_FontOpenTypeFeatureInterface', tag: string, secondaryTags: Array<string>, label: string | null, description: string | null, example: string | null, allGlyphs: string | null, loadAsDefault: boolean, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleInterface', id: string, name: string, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, otfFiles: { __typename: 'CMS_SSR_FontFilesInterface', metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null }> }>, vfRomanFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, woff2FileSize: number | null, metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null, vfItalicFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, woff2FileSize: number | null, metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, subfamilies: Array<{ __typename: 'CMS_SSR_FontSubfamilyInterface', name: string }>, mainSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null, campaign: { __typename: 'CMS_SSR_CampaignInterface', type: CMS_SSR_CampaignsCampaignTypeChoices, displayMode: CMS_SSR_CampaignsCampaignDisplayModeChoices, transitionDuration: number, transitionInterval: number, svgHeadingOverlay: boolean, images: Array<{ __typename: 'CMS_SSR_CampaignImageInterface', id: string, sortOrder: number, imageLandscape: string, imageLandscapeWidth: number, imageLandscapeHeight: number, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, imagePortrait: string | null, imagePortraitWidth: number | null, imagePortraitHeight: number | null, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorLoaderForeground: string | null, colorLoaderBackground: string | null, colorBackground: string | null }>, videos: Array<{ __typename: 'CMS_SSR_CampaignVideoInterface', id: string, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorLoaderForeground: string | null, colorLoaderBackground: string | null, videoLandscape: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> }, videoPortrait: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> } | null }> } | null, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleInterface', id: string, name: string, weight: number, pointSize: number | null, pixelSize: number | null, unitPrice: number, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontSizeMultiplier: number, typographicRanking: number | null, openTypeFeatures: Array<{ __typename: 'CMS_SSR_FontOpenTypeFeatureInterface', tag: string, label: string | null }>, ttfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, woff2FileSize: number | null } | null, otfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woffFile: string, metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, fontSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } }>, mainFontStyle: { __typename: 'CMS_SSR_FontStyleInterface', id: string, name: string, weight: number, pointSize: number | null, pixelSize: number | null, unitPrice: number, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontSizeMultiplier: number, typographicRanking: number | null, openTypeFeatures: Array<{ __typename: 'CMS_SSR_FontOpenTypeFeatureInterface', tag: string, label: string | null }>, ttfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, woff2FileSize: number | null } | null, otfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woffFile: string, metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, fontSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } }, awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number }>, notableDetails: Array<{ __typename: 'CMS_SSR_FontFamilyNotableDetailInterface', svg: string }>, featuredInUsePosts: Array<{ __typename: 'CMS_SSR_BlogIndexPage' } | { __typename: 'CMS_SSR_BlogPage' } | { __typename: 'CMS_SSR_FontsInUseDetailPage', id: string | null, title: string, seoTitle: string, slug: string, postDate: any, mediaCount: number, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag', id: string | null, name: string | null, slug: string | null }> | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', slug: string, name: string, typographicRanking: number | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string } }> | null } | { __typename: 'CMS_SSR_FontsInUseIndexPage' } | { __typename: 'CMS_SSR_HomePage' } | { __typename: 'CMS_SSR_Page' }> | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, name: string, slug: string, isCollection: boolean, informationIntro: string | null, pdfSpecimen: string | null, typographicRanking: number | null, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }>, designInformationPage: { __typename: 'CMS_SSR_BlogPage', slug: string } | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', slug: string, name: string, isPreRelease: boolean, fontStyleCount: number, typographicRanking: number | null, subfamilies: Array<{ __typename: 'CMS_SSR_FontSubfamilyInterface', name: string }> }>, awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number }> } }> } };

export type BigSpecimenSetQueryVariables = Exact<{
  fontFamily: Scalars['ID'];
  contentAmount: Scalars['Int'];
}>;


export type BigSpecimenSetQuery = { ssr: { __typename: 'CMS_SSR', bigSpecimenSet: { __typename: 'CMS_SSR_BigSpecimenSet', lineHeight: number, letterSpacing: number, specimensPerFontStyle: number, referenceWordCalculatedWidth: number, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleWithWords', id: string, name: string, fontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, words: Array<{ __typename: 'CMS_SSR_SpecimenWord', width: number, content: string, contentAscii: string, opentypeFeatures: Array<string> | null }>, variableAxes: Array<{ __typename: 'CMS_SSR_FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number } | null> | null }> } | null } };

export type MediumSpecimenSetQueryVariables = Exact<{
  fontFamily: Scalars['ID'];
  contentAmount: Scalars['Int'];
}>;


export type MediumSpecimenSetQuery = { ssr: { __typename: 'CMS_SSR', mediumSpecimenSet: { __typename: 'CMS_SSR_MediumSpecimenSet', fontSize: number, lineHeight: number, letterSpacing: number, fixedOpentypeFeatures: Array<string> | null, randomOpentypeFeatures: Array<string> | null, randomOpentypeLikelihood: number, specimensPerFontStyle: number, sentences: Array<string>, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleWithCorrespondingStyles', id: string, name: string, italicStyleId: string | null, boldStyleId: string | null, fontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, variableAxes: Array<{ __typename: 'CMS_SSR_FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number } | null> | null }> } | null } };

export type SmallSpecimenSetQueryVariables = Exact<{
  fontFamily: Scalars['ID'];
  contentAmount: Scalars['Int'];
}>;


export type SmallSpecimenSetQuery = { ssr: { __typename: 'CMS_SSR', smallSpecimenSet: { __typename: 'CMS_SSR_SmallSpecimenSet', fontSize: number, lineHeight: number, letterSpacing: number, columns: number, fixedOpentypeFeatures: Array<string> | null, randomOpentypeFeatures: Array<string> | null, randomOpentypeLikelihood: number, wordsInSmallCaps: number, lineCount: number, columnsSecondary: number, fontSizeSecondary: number, lineCountSecondary: number, sentences: Array<string>, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleWithCorrespondingStyles', pixelSize: number | null, id: string, name: string, italicStyleId: string | null, boldStyleId: string | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null, variableAxes: Array<{ __typename: 'CMS_SSR_FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number } | null> | null }> } | null } };

export type FontFamilyGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type FontFamilyGroupsQuery = { ssr: { __typename: 'CMS_SSR', fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, informationIntro: string | null, isCollection: boolean, name: string, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontStyleCount: number, fontSizeMultiplier: number, slug: string, unitPrice: number, svgHeading: string | null, seoTitle: string, seoDescription: string, seoImage: string, pdfSpecimen: string | null, typographicRanking: number | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, designInformationPage: { __typename: 'CMS_SSR_BlogPage', slug: string } | null, campaign: { __typename: 'CMS_SSR_CampaignInterface', type: CMS_SSR_CampaignsCampaignTypeChoices, displayMode: CMS_SSR_CampaignsCampaignDisplayModeChoices, transitionDuration: number, transitionInterval: number, svgHeadingOverlay: boolean, images: Array<{ __typename: 'CMS_SSR_CampaignImageInterface', id: string, sortOrder: number, imageLandscape: string, imageLandscapeWidth: number, imageLandscapeHeight: number, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, imagePortrait: string | null, imagePortraitWidth: number | null, imagePortraitHeight: number | null, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorLoaderForeground: string | null, colorLoaderBackground: string | null, colorBackground: string | null }>, videos: Array<{ __typename: 'CMS_SSR_CampaignVideoInterface', id: string, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorLoaderForeground: string | null, colorLoaderBackground: string | null, videoLandscape: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> }, videoPortrait: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> } | null }> } | null, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }>, awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number }>, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', classification: Array<string>, creditDesign: Array<string>, creditEngineering: Array<string>, creditCollaborators: Array<string>, fontStyleCount: number, id: string, name: string, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontSizeMultiplier: number, isPreRelease: boolean, slug: string, seoImage: string, release: any | null, supportedLanguages: Array<string>, unitPrice: number, typographicRanking: number | null, hasVariableFonts: boolean, versionNumber: number | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, vfRomanFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, woff2FileSize: number | null, metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null, vfItalicFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, woff2FileSize: number | null, metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, mainFontStyle: { __typename: 'CMS_SSR_FontStyleInterface', id: string, name: string, weight: number, pointSize: number | null, pixelSize: number | null, unitPrice: number, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontSizeMultiplier: number, typographicRanking: number | null, openTypeFeatures: Array<{ __typename: 'CMS_SSR_FontOpenTypeFeatureInterface', tag: string, label: string | null }>, ttfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, woff2FileSize: number | null } | null, otfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woffFile: string, metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, fontSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } }, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleInterface', id: string, name: string, weight: number, pointSize: number | null, pixelSize: number | null, unitPrice: number, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontSizeMultiplier: number, typographicRanking: number | null, openTypeFeatures: Array<{ __typename: 'CMS_SSR_FontOpenTypeFeatureInterface', tag: string, label: string | null }>, ttfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2File: string | null, woff2FileSize: number | null } | null, otfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woffFile: string, metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightOs2: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, fontSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } }>, awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number }>, subfamilies: Array<{ __typename: 'CMS_SSR_FontSubfamilyInterface', name: string }>, mainSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null }> }> } };

export type InUsePostPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type InUsePostPagesQuery = { ssr: { __typename: 'CMS_SSR', inUsePosts: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPage', slug: string, title: string, seoTitle: string, noindex: boolean, mediaCount: number, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, placeholderColor: string | null, hasAlpha: boolean | null }, feedImage: { __typename: 'CMS_SSR_CustomImage', file: string } | null, designerLinks: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink', name: string | null, url: string | null } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock' } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null, body: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock', singleImageLayout: CMS_SSR_SingleImageLayoutChoice, colorBackground: string | null, noVerticalMargins: boolean | null, showBackground: boolean | null, content: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock', image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock', video: string, videoAspectRatio: string | null } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null } | { __typename: 'CMS_SSR_SimpleVideoBlock', video: string, videoAspectRatio: string | null } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, name: string, slug: string, isPreRelease: boolean, typographicRanking: number | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, slug: string, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }> } }> | null, categories: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag', name: string | null, slug: string | null, id: string | null }> | null }> | null } };

export type InUseDesignerLinkFragment = { __typename: 'CMS_SSR_DesignerLink', name: string | null, url: string | null };

export type InUseSimpleVideoBlockFragment = { __typename: 'CMS_SSR_SimpleVideoBlock', video: string, videoAspectRatio: string | null };

export type InUseSimpleImageBlockFragment = { __typename: 'CMS_SSR_SimpleImageBlock', image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null };

export type InUseSimpleImageSectionBlockFragment = { __typename: 'CMS_SSR_SimpleImageSectionBlock', singleImageLayout: CMS_SSR_SingleImageLayoutChoice, colorBackground: string | null, noVerticalMargins: boolean | null, showBackground: boolean | null, content: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock', image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock', video: string, videoAspectRatio: string | null } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null };

export type CustomFontsPostPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomFontsPostPagesQuery = { ssr: { __typename: 'CMS_SSR', customFonts: Array<{ __typename: 'CMS_SSR_CustomFontInterface', id: string, name: string, slug: string | null, svgHeading: string | null, bitmapHeading: string | null, informationIntro: string | null, creditDesign: Array<string>, creditClient: Array<string>, creditAgency: Array<string>, creditCollaborators: Array<string>, seoTitle: string, seoImage: string, seoDescription: string, backgroundColor: string, foregroundColor: string, highlightColor: string, styles: Array<{ __typename: 'CMS_SSR_CustomFontStyleInterface', id: string, name: string, svg: string, weight: number, family: { __typename: 'CMS_SSR_CustomFontFamilyInterface', id: string, name: string, sortOrder: number } | null }>, families: Array<{ __typename: 'CMS_SSR_CustomFontFamilyInterface', id: string, svg: string | null, sortOrder: number }>, designInformationPage: { __typename: 'CMS_SSR_BlogPage', slug: string } | null, specimens: Array<{ __typename: 'CMS_SSR_CustomFontSpecimenInterface', id: string, name: string, sortOrder: number, svg: string | null, bitmap: string | null, family: { __typename: 'CMS_SSR_CustomFontFamilyInterface', id: string, name: string, sortOrder: number } | null }>, images: Array<{ __typename: 'CMS_SSR_CustomFontImageInterface', id: string, image: string, feature: boolean, sortOrder: number }>, awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number }> }> } };

export type InUseCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type InUseCategoriesQuery = { ssr: { __typename: 'CMS_SSR', inUseCategories: Array<{ __typename: 'CMS_SSR_TagInterface', slug: string, name: string }> } };

export type BlogPostStubsQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogPostStubsQuery = { ssr: { __typename: 'CMS_SSR', blogPosts: Array<{ __typename: 'CMS_SSR_BlogPage', noindex: boolean, blurb: string | null, id: string | null, title: string, seoTitle: string, slug: string, postDate: any, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_BlogTag', id: string | null, name: string | null, slug: string | null }>, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string }> | null }> | null } };

export type BlogPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogPostsQuery = { ssr: { __typename: 'CMS_SSR', blogPosts: Array<{ __typename: 'CMS_SSR_BlogPage', id: string | null, noindex: boolean, title: string, seoTitle: string, searchDescription: string | null, blurb: string | null, slug: string, postDate: any, intro: string | null, author: string | null, lastPublishedAt: any | null, expireAt: any | null, categories: Array<{ __typename: 'CMS_SSR_BlogTag', id: string | null, name: string | null, slug: string | null }>, feedImage: { __typename: 'CMS_SSR_CustomImage', file: string } | null, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, body: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock', footNotes: string | null, textContent: string } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock', title: string } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock', heading: string | null, singleImageLayout: CMS_SSR_SingleImageLayoutChoice, colorBackground: string | null, noVerticalMargins: boolean | null, colorText: string | null, showBackground: boolean | null, content: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock', caption: string | null, image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock' } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock', video: string, videoAspectRatio: string | null, caption: string | null } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock', question: string, answer: string } | { __typename: 'CMS_SSR_QuoteBlock', quote: string, caption: string | null } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock' } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock', video: string, caption: string | null, videoAspectRatio: string | null, thumbnailUrl: string | null, accessibilityTitle: string | null, posterImage: { __typename: 'CMS_SSR_CustomImage', file: string } | null } | null> | null, hero: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock', field: string, landscapeImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number } | null, landscapeSvg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null, portraitImage: { __typename: 'CMS_SSR_CustomImage', file: string, height: number, width: number } | null, portraitSvg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock' } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, name: string, slug: string, svgNavigation: string | null, informationIntro: string | null, isCollection: boolean, isNew: boolean, showInCustomFontMenu: boolean, typographicRanking: number | null, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }>, designInformationPage: { __typename: 'CMS_SSR_BlogPage', slug: string } | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, slug: string, name: string, isPreRelease: boolean, fontStyleCount: number, typographicRanking: number | null }> }> | null, relatedBlogPosts: Array<{ __typename: 'CMS_SSR_BlogPage', noindex: boolean, blurb: string | null, id: string | null, title: string, seoTitle: string, slug: string, postDate: any, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_BlogTag', id: string | null, name: string | null, slug: string | null }>, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string }> | null }> }> | null } };

export type BlogContentWithFootNotesBlockFragment = { __typename: 'CMS_SSR_ContentWithFootNotesBlock', footNotes: string | null, textContent: string };

export type BlogVideoBlockFragment = { __typename: 'CMS_SSR_VideoBlock', video: string, caption: string | null, videoAspectRatio: string | null, thumbnailUrl: string | null, accessibilityTitle: string | null, posterImage: { __typename: 'CMS_SSR_CustomImage', file: string } | null };

export type BlogHeadingBlockFragment = { __typename: 'CMS_SSR_HeadingBlock', title: string };

export type BlogSimpleVideoCaptionBlockFragment = { __typename: 'CMS_SSR_SimpleVideoCaptionBlock', video: string, videoAspectRatio: string | null, caption: string | null };

export type BlogImageBlockFragment = { __typename: 'CMS_SSR_ImageBlock', caption: string | null, image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null };

export type BlogImageSectionBlockFragment = { __typename: 'CMS_SSR_ImageSectionBlock', heading: string | null, singleImageLayout: CMS_SSR_SingleImageLayoutChoice, colorBackground: string | null, noVerticalMargins: boolean | null, colorText: string | null, showBackground: boolean | null, content: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock', caption: string | null, image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock' } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock', video: string, videoAspectRatio: string | null, caption: string | null } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null };

export type BlogQuoteBlockFragment = { __typename: 'CMS_SSR_QuoteBlock', quote: string, caption: string | null };

export type BlogQuestionAndAnswerBlockFragment = { __typename: 'CMS_SSR_QuestionAndAnswerBlock', question: string, answer: string };

export type BlogHeroImageFragment = { __typename: 'CMS_SSR_ImageWithPortraitBlock', field: string, landscapeImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number } | null, landscapeSvg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null, portraitImage: { __typename: 'CMS_SSR_CustomImage', file: string, height: number, width: number } | null, portraitSvg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null };

export type BlogCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogCategoriesQuery = { ssr: { __typename: 'CMS_SSR', blogCategories: Array<{ __typename: 'CMS_SSR_BlogTagInterface', id: string, name: string, slug: string }> } };
